import * as axiosAPIBlog from '../../api/admin/blog';
import * as wexAPIMenu from '../../api/admin/menu';
import {
    axiosAddMenu,
    axiosUpdateMenu,
    axiosSaveMenu,
    axiosDeleteMenu,
    axiosSaveHeaderStyle,
    axiosSaveTopMenuStyle,
    axiosSaveMenuStyle,
    axiosSaveSite,
    axiosSaveSettingBrand,
    axiosResetSidebar,
} from '../../api/admin/default';

window.arr_deletemenu = [];
window.menuNavID = false;
window.menuSlug = false;
window.isSidebar = 0;
window.eventBrand = false;
window.rvslideshow;
window.isCusHeader = false;
window.firstBanner = true;
window.useBanner = true;

(function ($) {
    RVwys.plugin['Header'] = true;
    RVwys.BannerDesign = {};
    RVwys.HeaderDesign = {};
    RVwys.Custombanner = {};
    RVwys.Brand = {};
    RVwys.Nav = {};
    RVwys.Sidebar = {};

    $(document).bind('editorReady', function () {
        //		Brand

        $('#sitebrand').val(parent.wex.site.site_brand);

        $('.email').keyup(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;
            const thisEle = RVwys.FindElement('#emailContactFooter');
            thisEle.text($(this).val());

            const eleIcon = thisEle.closest('.tableCell').prev();
            eleIcon.toggle(Boolean($(this).val()));
        });

        $('.contactTitle').keyup(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;
            RVwys.FindElement('#titleContact').text($(this).val());
        });

        $('.address').keyup(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;
            const thisEle = RVwys.FindElement('#addressContactFooter');
            thisEle.text($(this).val());

            const eleIcon = thisEle.closest('.tableCell').prev();
            eleIcon.toggle(Boolean($(this).val()));
        });

        $('.tel').keyup(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;

            var isTel = RVwys.FindElement('tel');
            var rTel = $('.tel').val();
            var cutTel = rTel.split(',');
            var valiTel = cutTel[0].replace(
                /[a-zA-Z]|\.?\-?\(?\)?\,?\s?/gim,
                ''
            );

            if (isTel.parent().is('a[href]')) {
                isTel.parent().removeAttr('href');
            }

            if (isTel.parent().is('a')) {
                isTel.parent().attr('data-href', `tel:${valiTel}`);
            }
            setTimeout(() => {
                isTel.text(rTel);
                if (rTel.length != 0) {
                    isTel.prepend(
                        $('<i class="uk-icon uk-icon-small uk-icon-phone"></i>')
                    );
                }
            }, 50);
        });

        //		Navigation Properties
        var fb = $('#frameBody').get(0).contentWindow;

        $('.menu_type').click(function () {
            console.log('Event Click: .menu_type');
            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find('li[menu-id="' + fb.menuNavID + '"]');
            console.log('oNavMenu: ', oNavMenu);
            var slug_id = fb.menuSlug;
            var isValueType = $(this).val();
            var isCheckLinktoURL = isValueType == '4' ? true : false;

            console.log('isValueType: ', isValueType);

            $('#menu_typeUrl').toggle(isCheckLinktoURL);
            $('.NavSpage').toggle(!isCheckLinktoURL);
            $('.NavBookmark').toggle(!isCheckLinktoURL);
            if (isCheckLinktoURL) {
                var regex = new RegExp(wex.url.baseUrl, 'img');
                if (oNavMenu.attr('menu-url').match(regex)) {
                    $('#menu_typeUrl').val('');
                } else {
                    var menuHref =
                        oNavMenu.attr('menu-url') == 'javascript:void(0)'
                            ? ''
                            : oNavMenu.attr('menu-url');
                    $('#menu_typeUrl').val(menuHref);
                }
            } else {
                RVwys.uikit.SelectPageNavigation(isValueType, slug_id);
            }
        });

        //     	แก้ไขชื่อ
        $('#page_name')
            .keyup(function () {
                var page_name = $(this).val();
                var oNavMenu = fb
                    .$('#selected_navigator,#selected_topmenu')
                    .find('li[menu-id="' + fb.menuNavID + '"]');
                var NavIcon = $(oNavMenu.find('span i')[0]).prop('outerHTML');
                oNavMenu
                    .children('a')
                    .children('span')
                    .html(NavIcon + ' ' + page_name + ' ');
            })
            .focusout(function () {
                var page_name = $(this).val();
                var oNavMenu = fb
                    .$('#selected_navigator,#selected_topmenu')
                    .find('li[menu-id="' + fb.menuNavID + '"]');

                axiosUpdateMenu({
                    type: 'rename',
                    menu_id: fb.menuNavID,
                    title: page_name,
                }).then(() => {
                    oNavMenu.attr('menu-title', page_name);
                });
            })
            .keyup(function (e) {
                if (e.keyCode == '13') {
                    $(this).trigger('focusout');
                }
            });

        //  เคลีย์ไอคอน
        $('#icon-clear').click(function () {
            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find('li[menu-id="' + fb.menuNavID + '"]');

            axiosUpdateMenu({
                type: 'icon',
                menu_id: fb.menuNavID,
                icon: '',
            }).then(response => {
                var ClassIcon = $('#ViewIconMenu').attr('class').split(' ')[0];

                $('#ViewIconMenu').removeClass(ClassIcon);

                oNavMenu.attr('menu-icon', '');

                fb.$('#selected_navigator')
                    .find(`li[menu-id="${response.data}"] > .NavEdit`)
                    .children('span')
                    .children('i')
                    .removeClass()
                    .addClass('uk-icon');
            });
        });

        //     	Show/Hide Badge Style
        $('#badge_title').keyup(function () {
            if ($('#badge_title').val() == '') {
                $('.NavBadgeStyle').fadeOut(500);
            } else {
                $('.NavBadgeStyle').fadeIn(500);
            }
        });

        //     	Save Badge Title
        $('#badge_title')
            .focusout(function () {
                var oNavMenu = fb
                    .$('#selected_navigator,#selected_topmenu')
                    .find('li[menu-id="' + fb.menuNavID + '"]');
                var badge_title = $('#badge_title').val();
                var oBadge = oNavMenu.children('.NavEdit').find('div');

                var badge_Style = oBadge.attr('class').split(' ')[1];
                var isBadge_Style = badge_Style.match(/uk-badge-(\w*)/)
                    ? badge_Style.match(/uk-badge-(\w*)/)[1]
                    : 'transparent';

                var badge_Style_UI = badge_Style;

                if ($(this).val() != '') {
                    if (isBadge_Style == 'transparent') {
                        badge_Style_UI = 'uk-badge-red';
                        oNavMenu.attr('menu-badge-style', badge_Style_UI);
                        oBadge.removeClass('uk-badge-' + isBadge_Style);
                        oBadge.addClass(badge_Style_UI);
                    }
                } else {
                    badge_Style_UI = 'uk-badge-transparent';
                    oNavMenu.attr('menu-badge-style', badge_Style_UI);
                    oBadge.removeClass('uk-badge-' + isBadge_Style);
                    oBadge.addClass(badge_Style_UI);
                }

                axiosUpdateMenu({
                    type: 'badge',
                    menu_id: fb.menuNavID,
                    badge_title: badge_title,
                    badge_style: badge_Style_UI,
                }).then(() => {
                    oNavMenu.children('a').find('.uk-badge').text(badge_title);
                    oNavMenu.attr('menu-badge-title', badge_title);
                });
            })
            .keyup(function (e) {
                if (e.keyCode == '13') {
                    $(this).trigger('focusout');
                }
            });

        //		choose color badge
        $('.colorgroupmenu .ui-badge-padd').click(function () {
            $('.ui-badge-padd').removeClass('uk-badge-active');
            $(this).addClass('uk-badge-active');

            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find('li[menu-id="' + fb.menuNavID + '"]');
            var colorBadge = $(this).attr('class').split(' ')[1];

            var getOldColorClass = oNavMenu.find('.uk-badge').attr('class'),
                getOldColorClass = getOldColorClass.match(/uk-badge-(\w*)/);
            console.log('getOldColorClass: ', getOldColorClass);

            var badge_title = $('#badge_title').val();

            axiosUpdateMenu({
                type: 'badge',
                menu_id: fb.menuNavID,
                badge_title: badge_title,
                badge_style: colorBadge,
            }).then(() => {
                oNavMenu
                    .children('a')
                    .find('.uk-badge')
                    .removeClass(`uk-badge-${getOldColorClass[1]}`)
                    .addClass(colorBadge);

                oNavMenu.attr('menu-badge-style', colorBadge);
            });
        });

        $('#menu-target').change(function () {
            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find('li[menu-id="' + fb.menuNavID + '"]');
            var Seltarget = $(this).find(':selected').attr('value');

            axiosUpdateMenu({
                type: 'target',
                menu_id: fb.menuNavID,
                target: Seltarget,
            }).then(() => {
                oNavMenu.attr('menu-target', Seltarget);
                oNavMenu.find('.NavEdit').attr('target', Seltarget);
            });
        });

        $('#menu_typeUrl')
            .focusout(function () {
                var oNavMenu = fb
                    .$('#selected_navigator,#selected_topmenu')
                    .find('li[menu-id="' + fb.menuNavID + '"]');
                var Seltarget = $('#menu-target')
                    .find(':selected')
                    .attr('value');
                var urlLink = $('#menu_typeUrl').val();

                if (!urlLink.match(/(http|https)/)) {
                    if (urlLink.match(/^#/) || urlLink == '') {
                        urlLink = '#';
                    } else {
                        urlLink = 'https://' + urlLink;
                    }
                }

                axiosUpdateMenu({
                    type: 'url',
                    menu_type: 4,
                    menu_id: fb.menuNavID,
                    target_id: Seltarget,
                    slug: '0',
                    url: urlLink,
                }).then(() => {
                    if (urlLink == '#') {
                        urlLink = 'javascript:void(0)';
                    }

                    oNavMenu.attr('menu-url', urlLink);
                    oNavMenu.attr('menu-type', 4);
                    oNavMenu.find('.NavEdit').attr('href', urlLink);
                });
            })
            .keyup(function (e) {
                if (e.keyCode == '13') {
                    $(this).trigger('focusout');
                }
            });

        $('#Navpage').change(function () {
            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find('li[menu-id="' + fb.menuNavID + '"]');
            var Slug_id = $(this).find(':selected').attr('id');
            var Slug_name = $(this).find(':selected').attr('value');
            var Slug_url = $(this).find(':selected').val();
            var Seltarget = $('#menu-target').find(':selected').attr('value');
            var menu_type = $('.menu_type:checked').val();

            axiosUpdateMenu({
                type: 'url',
                menu_id: fb.menuNavID,
                menu_type: menu_type,
                slug: Slug_id,
                target_id: Seltarget,
                url: '',
            }).then(() => {
                oNavMenu.attr('slug-id', Slug_id);
                oNavMenu.attr('menu-type', menu_type);
                oNavMenu.attr('menu-slug', Slug_name);
                oNavMenu.attr(
                    'menu-url',
                    `${wex.url.baseUrl}/${Slug_url.replace(/\s/g, '')}`
                );

                oNavMenu.find('.NavEdit').attr(
                    'href',
                    `${wex.url.baseUrl}
                        /admin/wysiwyg/uikit/show/
                        ${Slug_url.replace(/\s/g, '')}`
                );
            });
        });
        //     	End Navigation Propreties

        //     	Custom Sidebar
        if (parent.$('#isMasterHeader').val() == '0') {
            RVwys.Sidebar.CustomSidebarDesign();
        }

        $('#s_duration').bind('keyup mouseup', function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var s_duration = parseInt($(this).val()) * 1000;

            parent.rvslideshow = UIkit.slideshow(fb.$('#rvs-uk-slide').get(0));
            parent.rvslideshow.stop();
            parent.rvslideshow.options.duration = s_duration;
            parent.rvslideshow.options.autoplay = true;
            parent.rvslideshow.options.autoplayInterval = 7000;
            parent.rvslideshow.options.pauseOnHover = true;
            parent.rvslideshow.start();

            fb.$('#rvs-uk-slide').attr({
                'data-duration': $(this).val(),
            });
        });

        $('.setBanner').click(function () {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var s_animation = $(this).attr('set');
            var s_duration = parseInt($('#s_duration').val()) * 1000;

            var mg = fb.$('#rvs-uk-slide');
            mg.find('.uk-cover-background').remove();
            mg.find('.uk-slideshow-ghost').remove();
            var mgClone = mg.clone();
            mg.after(mgClone);
            mg.remove();

            setTimeout(function () {
                UIkit.slideshow(mgClone, {
                    animation: s_animation,
                    autoplay: false,
                });
            }, 200);

            fb.$('#rvs-uk-slide').attr(
                'data-uk-slideshow',
                "{animation: '" + s_animation + "', autoplay: 'true'}"
            );
            fb.$('#rvs-uk-slide').attr({
                'data-duration': $('#s_duration').val(),
            });
        });
    });

    RVwys.sortHeader = function () {
        //		parent.$('#frameBody').attr('scrolling','no');

        var hasOverlap = $('.selected_overlap').hasClass('overlap');

        if (hasOverlap) {
            var UI = parent.UIkit;

            var onInsert = function () {
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('No Menu Sort') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        rvLang(
                            'You are using an overlapping menu. For a perfect appearance, we do not recommend to sort menu.'
                        ) +
                        '</span></div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('OK') +
                        '</button>',
                    '</div>',
                ].join('')
            );

            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });

            modal.show();
        } else {
            var overlaypanel = $('<div class="overlaysortheader"></div>').css({
                width: $('body').width(),
                height: $('body').height(),
                zIndex: '99999',
            });
            $('body').prepend(overlaypanel);
            parent.$('body').prepend(
                overlaypanel.clone().css({
                    height: parent.$('#topbar').height(),
                })
            );
            $('#selected_header').css({
                zIndex: '99999',
                position: 'relative',
                /*		'overflow': 'scroll',
									'height':parent.$('#frameBody').css('height')*/
            });
            var HtmlOverlaySort = $(
                '<div class="disableBanner uk-overlay-panel"></div>'
            ).css({
                width: $('#selected_headerbanner').width(),
                height: $('#selected_headerbanner').height(),
                zInedx: 9,
            });
            var ButtonClose = $(
                '<div class="bar-apply"><button title="' +
                    rvLang('Close Sort Header') +
                    '"><i class="uk-icon rv-icon-sort-close"></i></button><div class="sort-boxcontent"><div class="sort-content"><span class="icon-sort"></span><span>' +
                    rvLang('Sort between Topmenu, Menu and Banner') +
                    '</span></div></div></div>'
            );
            $('#selected_headerbanner .mg').append(HtmlOverlaySort);
            $('#selected_header').prepend(ButtonClose);
            ButtonClose.click(function () {
                $(this).remove();
                $('.overlaysortheader').remove();
                $('.disableBanner').remove();
                parent.$('.overlaysortheader').remove();

                $('#selected_header section[id^=selected_]').removeAttr(
                    'style'
                );
                $('#selected_header').removeAttr('style');
                $('#selected_header>div').sortable('destroy');
            });

            $('#selected_header>div').sortable({
                axis: 'y',
                cancel: '#selected_headerbanner',
                appendTo: 'body',
                opacity: '.5',
                placeholder: {
                    element: function (clone, ui) {
                        return $(
                            '<section class="selected">' +
                                clone[0].innerHTML +
                                '</section>'
                        );
                    },
                    update: function () {
                        return;
                    },
                },
                start: function (e, ui) {
                    $(ui.item).css({
                        cursor: '-webkit-grabbing',
                    });
                },
                stop: function (e, ui) {
                    $(ui.item).css({
                        cursor: '-webkit-grab',
                    });
                },
            });
        }
    };

    $(document).bind('designReady', function () {
        parent.$('.button-save-headerBanner').click(function () {
            parent.$('.wys-rowHeaderBanner').hide();
            RVwys.HeaderDesign.SaveBanner();
        });

        parent.$('.button-save-slideBanner').click(function () {
            RVwys.HeaderDesign.SaveBanner();
        });

        //		Hide Banner
        parent.$('#banner_onoff').change(function () {
            if (this.checked) {
                $('#selected_headerbanner').addClass('uk-hidden');
                parent.$('#NoBanner').addClass('disabled');
            } else {
                $('#selected_headerbanner').removeClass('uk-hidden');
                parent.$('#NoBanner').removeClass('disabled');
            }
        });

        RVwys.Brand.Event();
        //		::TODO EventSave
        parent.$('.event-brand').on('keyup change', function () {
            window.eventBrand = true;
            //
        });

        parent.$('#LinkTel').change(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;
            var isTel = $(this).prop('checked');
            var trimTel = parent.$('.tel').val().split(',');
            var telValidateNum = trimTel[0].replace(
                /[a-zA-Z]|\.?\-?\(?\)?\,?\s?/gim,
                ''
            );

            if (isTel) {
                if (!$('tel').parent().is('a')) {
                    $('tel').wrap(`<a data-href=tel:${telValidateNum}></a>`);
                } else {
                    $('tel')
                        .parent()
                        .attr('data-href', `tel:${telValidateNum}`);
                }
            } else {
                $('tel').unwrap();
            }
        });

        //		 Navigation
        var oThis = $(
            '#selected_navigator li>a,#selected_topmenu li[menu-id]>a,#sitemapFooter a.footerLink'
        );
        oThis.each(function () {
            var menuslug = $(this).parent().attr('menu-slug');
            var menubookmark = $(this).parent().attr('menu-bookmark');

            $(this).attr('target', '_parent');

            if ($(this).parent().attr('menu-type') != '4') {
                if (
                    typeof menuslug == 'undefined' &&
                    typeof menubookmark == 'undefined'
                ) {
                    menuslug = $(this).attr('menu-slug');
                    menubookmark = $(this).attr('menu-bookmark');
                }

                /*					var url = ($(this).parent().attr('menu-type') == '2')? url = 'blog/'+menuslug+menubookmark : 	url = menuslug+menubookmark;
						$(this).attr('href',parent.WYS_SHOW_URL+"/"+url);*/
                $(this).attr(
                    'href',
                    parent.wex.url.WYS_SHOW_URL + '/' + menuslug + menubookmark
                );
                $(this).unbind('click');
            } else {
                if ($(this).parent().attr('menu-url') != '#') {
                    $(this).attr('target', '_blank');
                    $(this).unbind('click');
                } else {
                    $(this).attr('href', 'javascript:void(0)');
                }
            }
        });

        parent.$('#overlap_onoff').change(function () {
            if (this.checked) {
                $('.selected_overlap').addClass('overlap');
                if ($('#selected_navigator').css('display') == 'none') {
                    $('#selected_navigator').css('display', '');
                    parent
                        .$('#menu_onoff')
                        .prop('checked', true)
                        .trigger('change');
                }

                RVwys.Custombanner.EventBanner();
            } else {
                $('.selected_overlap').removeClass('overlap');
            }
        });

        parent.$('#menu_onoff').change(function () {
            if (this.checked) {
                $('#selected_navigator').css('display', '');
            } else {
                $('#selected_navigator').css({
                    display: 'none',
                });
                parent
                    .$('#overlap_onoff')
                    .prop('checked', false)
                    .trigger('change');
            }
        });

        $('#menu-nav-setting').click(function (e) {
            parent.$('#frameBody').attr('scrolling', 'no');
            var hasOverlap = $('.selected_overlap').hasClass('overlap');

            if (hasOverlap) {
                $('.selected_overlap').removeClass('overlap');
            }

            var selected_navigator_css = $('#selected_navigator').css(
                'display'
            );

            if (selected_navigator_css == 'none') {
                parent.$('#show_menu').trigger('click');
            }

            arr_deletemenu = [];
            parent.RVwys.hidePanelAll();

            var oThis = $('[menu-current-page="1"]').first();

            if (oThis.length == 0) {
                oThis = $('#selected_navigator [menu-id]').first();
            }

            RVwys.uikit.showPanelNavgation(oThis);

            var DisableHerf = $('#selected_navigator li>a');
            DisableHerf.attr('onclick', 'return false;');
            //			OverlayDisplayMenu
            var overlaypanel = $('<div class="overlaymenu"></div>').css({
                width: $('body').width(),
                height: $('body').height(),
                zIndex: '99999',
            });
            $('body').prepend(overlaypanel);
            parent.$('body').prepend(
                overlaypanel.clone().css({
                    height: parent.$('#topbar').height(),
                })
            );
            $('#selected_navigator').css({
                zIndex: '99999',
                position: 'relative',
            });

            $('.NavDesign').hide();
            $('.NavManager,.foreditmode').show();

            $('#selected_navigator')
                .find('.uk-active')
                .removeClass('uk-active');
            $('#selected_navigator').find(oThis).addClass('uk-active');
            $('#selected_navigator')
                .find('.js-right-nav ul')
                .children()
                .children()
                .addClass('NavEdit');
            $('#selected_navigator')
                .find('.js-left-nav  ul')
                .children()
                .children()
                .addClass('NavEdit');

            var oNavbar = $('nav.uk-navbar');
            //
            //
            oNavbar
                .find('.js-right-nav > ul,.js-left-nav > ul')
                .addClass('navul');
            oNavbar
                .find('.uk-navbar-nav')
                .children()
                .not('.uk-parent')
                .append(
                    '<div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;"><ul class="uk-nav uk-nav-navbar dropdownop"></ul></div>'
                );
            oNavbar
                .find('.uk-dropdown > ul:has(li)')
                .children()
                .not(':has(.uk-nav-sub)')
                .append('<ul class="uk-nav-sub dropdownUILv2"></ul>');
            oNavbar
                .find('.uk-dropdown > ul')
                .find('li')
                .children()
                .next()
                .addClass('dropdownLv2');

            //			Delete Menu
            $('.uk-navbar .uk-navbar-nav li').each(function () {
                if ($(this).find('.foreditmode').length == 0) {
                    $(this).append($('.rowDeleteMenu').html());
                    RVwys.removeMenu($(this));
                }
            });

            RVwys.AddMenuSetting();
            RVwys.UISortMenu();
            RVwys.EvenMenu();

            parent.$('.overlaymenu').click(function () {
                $('.overlaymenu').trigger('click');
            });

            $('.overlaymenu').click(function (event) {
                parent.$('#frameBody').attr('scrolling', 'auto');
                var locationMenu = ['.js-left-nav', '.js-right-nav'];
                RVwys.SaveSortMenu(locationMenu);
                RVwys.EventRemove();

                if (hasOverlap) {
                    $('.selected_overlap').addClass('overlap');
                }
                //				สถานะเมนูก่อนแก้ไข
                $('#selected_navigator').css('display', selected_navigator_css);
            });

            $('#selected_navigator').bind('mousewheel', function () {
                return false;
            });
        });

        $('#menu-nav-cancel').click(function () {
            var oNavbar = $('nav.uk-navbar');

            $('.overlaymenu').remove();

            $('ul').removeClass('dropdownop');
            $('nav  ul').removeClass('navul');
            $('nav li').removeClass('uk-open');

            $('.dropdownop').removeClass('dropdownop');
            $('.uk-dropdown > ul:empty').parent().remove();
            $('.NavEdit').unbind();
            $('.NavEdit').removeClass('NavEdit');

            if (oNavbar.find('ul').eq(0).hasClass('ui-sortable')) {
                oNavbar.find('ul').sortable('destroy');
            }
            $('#selected_navigator')
                .find('li')
                .first()
                .removeClass('uk-active');
            $('.NavManager,.foreditmode').hide();
            $('.NavDesign').show();

            parent.RVwys.hidePanelAll();
        });

        $('#menu-nav-save').click(function () {
            var oNavbar = $('nav.uk-navbar');

            $('.overlaymenu').remove();
            $('.dropdownLv2:empty').remove();
            $('.dropdownLv2').removeClass('dropdownLv2');
            $('.dropdownUILv2:empty').remove();
            $('.dropdownUILv2').removeClass('dropdownUILv2');
            $('#selected_navigator').find('.foreditmode').remove();
            $('#selected_navigator')
                .find('li')
                .first()
                .removeClass('uk-active');
            $('#selected_navigator').removeAttr('style');
            $('#topmenu').removeAttr('style');

            $('ul').removeClass('dropdownop');
            $('nav  ul').removeClass('navul');
            $('nav li').removeClass('uk-open');

            RVwys.SaveSortMenu();
            oNavbar.find('.ui-sortable').sortable('destroy');
            $('.NavEdit').unbind();
            $('.NavEdit').removeClass('NavEdit');

            $('.dropdownop').removeClass('dropdownop');
            $('.uk-dropdown > ul:empty').parent().remove();

            //			e.defaultPrevented();
            $('.NavManager').hide();
            $('.NavDesign').show();
        });

        //		 End Navigation

        //		Topmenu

        parent.$('#login_onoff').change(function () {
            if (this.checked) {
                $('.top_login').css('display', '');
                RVwys.hideLoginMenu('1');
            } else {
                $('.top_login').css('display', 'none');
                RVwys.hideLoginMenu('0');
            }
        });
        $('#nav-setting').click(function () {
            //alert('s')
            parent.$('.wys-menuSettings').show();
            //frame
            var path =
                parent.wex.url.baseUrl + '/admin/wysiwyg/uikit/fixedmenu';
            var menuEditor = $(
                '<iframe id="menuEditor" name="menuEditor"  src="' +
                    path +
                    '" width="100%" height="' +
                    $(document).height() +
                    '"></iframe>'
            );
            menuEditor.on('load', function (e) {
                alert('load end');
            });
            parent.$('.menuEditor').append(menuEditor);
        });

        $('#topmenu-nav-setting').click(function () {
            //			Unbind Click
            var DisableHerf = $('#selected_topmenu li>a');
            DisableHerf.attr('onclick', 'return false;');

            parent.$('#frameBody').attr('scrolling', 'no');
            parent.RVwys.hidePanelAll();

            $('#topmenu')
                .find('.uk-subnav ')
                .prepend($('.rowAddmenuTop').html());
            $('.addMenutop').click(function () {
                var Count_Nav = $('#topmenu li[menu-id]').length + 1;
                var Tagli = $(
                    '<li menu-id="" slug-id="" menu-title="Topmenu ' +
                        Count_Nav +
                        '" menu-badge-style="" menu-badge-title="" menu-icon="" menu-target="" menu-url="" menu-type=""  location-type="3"><a class="NavEdit" href="javascript:void(0)" target="_self" ><span><i class="uk-icon"></i> Topmenu ' +
                        Count_Nav +
                        '</span></a><div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;"><ul class="uk-nav uk-nav-navbar dropdownop"></ul></div></li>'
                );
                $('top_nav .addMenutop').after(Tagli);
                Tagli.append($('.rowDeleteMenu').html());
                RVwys.EvenMenu(Tagli);
                RVwys.UISortMenu();
                RVwys.AjaxAddmenu(Tagli);
                RVwys.removeMenu(Tagli);
            });

            $('#selected_topmenu ul li:last-child').addClass('disableTopmenu');
            var oNavTop = $('#selected_topmenu li:not(.disableTopmenu)');
            var overlaypanel = $('<div class="overlaymenu"></div>').css({
                width: $('body').width(),
                height: $('body').height(),
                zIndex: '99999',
            });
            $('body').prepend(overlaypanel);
            parent.$('body').prepend(
                overlaypanel.clone().css({
                    height: parent.$('#topbar').height() + 1,
                })
            );
            $('#topmenu').css({
                zIndex: '99999',
                position: 'relative',
            });
            oNavTop.children('a').addClass('NavEdit');
            //			Delete Menu Top
            $('top_nav .uk-subnav li[menu-id]').each(function () {
                //
                if ($(this).find('.foreditmode').length == 0) {
                    $(this).append($('.rowDeleteMenu').html());
                    RVwys.removeMenu($(this));
                }
            });
            RVwys.EvenMenu();
            parent.$('.overlaymenu').click(function () {
                $('.overlaymenu').trigger('click');
            });

            $('.overlaymenu').click(function () {
                parent.$('#frameBody').attr('scrolling', 'auto');
                $('#selected_topmenu .foreditmode').remove();

                var locationMenu = ['.js-left-nav', '.js-right-nav', 'top_nav'];
                RVwys.SaveSortMenu(locationMenu);
                //				DELETE TOP MENU
                RVwys.DeleteMenu(arr_deletemenu);

                $('.disableTopmenu').removeClass('disableTopmenu');
                $('#topmenu').removeAttr('style');
                parent.RVwys.hidePanelAll();

                $('.NavEdit').unbind();
                $('.NavEdit').removeClass('NavEdit');
                $('#selected_topmenu ul li:last-child')
                    .find('.ui-sortable')
                    .sortable('destroy');
                $('.overlaymenu').remove();
                parent.$('.overlaymenu').remove();
                DisableHerf.removeAttr('onclick');
            });

            $('#selected_topmenu ul').sortable({
                items: 'li:not(.disableTopmenu)',
                placeholder: 'uk-icon-caret-down icon-red',
                cancel: '.disableTopmenu',
            });
        });
        //		End Topmenu

        //		HeaderDesign
        $('#editable_area_content-h').find('.blockDelete').remove();
        $('#selected_headerbanner').prepend($('.rowHeadsetting').html());
        RVwys.Custombanner.EventBanner();
        //		End HeaderDEsign

        RVwys.Sidebar.CustomSidebar();
    });

    RVwys.BannerDesign.EventSwitchSlide = function (oRodata, e) {
        if (document.getElementsByClassName('uk-dotnav')) {
            var dot = document.getElementsByClassName('uk-dotnav');
            [...dot].map(n => n && n.remove());
        }

        var previous = `<a href="" class="uk-slidenav uk-slidenav-contrast uk-slidenav-previous" data-uk-slideshow-item="previous"></a>`;
        var next = `<a href="" class="uk-slidenav uk-slidenav-contrast uk-slidenav-next" data-uk-slideshow-item="next"></a>`;
        var Navdot = `<ul class="uk-dotnav uk-dotnav-contrast uk-position-bottom uk-flex-center">
                            <li data-uk-slideshow-item="0"><a href=""></a></li>
                            <li data-uk-slideshow-item="1"><a href=""></a></li>
                        </ul>`;
        $('#rvs-uk-slide').append(previous);
        $('#rvs-uk-slide').append(next);
        $('#rvs-uk-slide').append(Navdot);

        $('#selected_headerbanner .SlideProperty').remove();

        var num = parent.$('.hvr-glow[banner=slide]').length;
        var random = Math.floor(Math.random() * num);

        var addSlide = parent
            .$('.hvr-glow[banner=slide]')
            .eq(random)
            .attr('data');
        oRodata.find('ul').append($(addSlide).find('li'));

        $('#rvs-uk-slide')
            .closest('[id^=editable_area_content]')
            .attr('id', 'editable_area_content-s');
        $('.uk-slidenav,.uk-dotnav').show();

        $('#rvs-uk-slide ul').first().replaceWith(oRodata.html());
        var dataNum = $('[data-slideshow-slide]').length;

        RVwys.HeaderDesign.RegisHeader(e);
        RVwys.BannerDesign.EventEditSlide();
        RVwys.BannerDesign.RegisRVSlide(dataNum);
    };

    RVwys.BannerDesign.EventSwitchHero = function (oRodata, e) {
        $('#rvs-uk-slide')
            .closest('[id^=editable_area_content]')
            .attr('id', 'editable_area_content-h');
        $('#rvs-uk-slide ul').first().replaceWith(oRodata.html());

        $('.uk-slidenav,.uk-dotnav').hide();
        $('#selected_headerbanner .SlideProperty').remove();

        RVwys.HeaderDesign.RegisHeader(e);
        RVwys.Brand.Event();
    };

    RVwys.BannerDesign.EventSlide = function () {
        var timeSlide =
            $('#rvs-uk-slide').data('duration') == 'undefined'
                ? 5
                : $('#rvs-uk-slide').data('duration');
        parent.$('#s_duration').val(timeSlide).change();
    };

    RVwys.BannerDesign.EventEditSlide = function () {
        //		  $('#editable_area_content-s #rvs-uk-slide').one('click',function(e){
        if ($('#selected_headerbanner .SlideProperty').length == 0) {
            var SlideProperty = parent.$('.SlideProperty').clone();
            $('#editable_area_content-s').before(SlideProperty);
            if (parent.$('#isHomepage').val() == '1') {
                $('.rv-Resetbanner').attr('style', 'display: none !important');
            }

            $('.uk-slideshow li').each(function (key) {
                var keynum = key + 1;
                var buttonSlide =
                    $(`<div class="uk-button btnSlide" data-slideshow-item="${key}">
                    <span>slide ${keynum}</span>
                    <a herf="" class="uk-icon-close delete-slide" title="Delete"></a>
                    <a href="javascript:void(0);" class="uk-icon uk-icon-photo bgSlide" id="BG_Slide" onclick="RVwys.uikit.blockprop.rowParallaxSlide('${key}')"  title="Change Image" style="display:none;"></a>
                    <a style="display:none;" class="uk-icon-clone clone-slide" title="Duplicate"></a>
                    </div>
                `);
                $(this).attr('data-banner', key);
                RVwys.BannerDesign.eButtonSlide(buttonSlide);
            });

            var ActiveBtn = $('[data-slideshow-item="0"]').addClass(
                'uk-active'
            );
            ActiveBtn.find('#BG_Slide').show();
            ActiveBtn.find('.delete-slide').hide();
            if ($('.overlap .SlideProperty')) {
                $('#countBanner').css(
                    'max-height',
                    $('#editable_area_content-s').height() - 115
                );
            } else {
                $('#countBanner').css(
                    'max-height',
                    $('#editable_area_content-s').height() - 30
                );
            }
        } else {
            $('#selected_headerbanner .SlideProperty').show();
        }

        //		  });
    };

    RVwys.BannerDesign.eButtonSlide = function (buttonSlide) {
        /* if($('[data-slideshow-item]').is('.uk-active')){
			$(this).find('.delete-slide').hide();
		} */

        buttonSlide.find('.delete-slide').click(function () {
            var KeySlide = $(this).parent().attr('data-slideshow-item');
            var UIkit = parent.UIkit;
            $(`[data-banner="${KeySlide}"]`).remove();
            $(`[data-uk-slideshow-item="${KeySlide}"]`).remove();

            $(this).parent().remove();

            if ($('[data-slideshow-item]').length == '1') {
                $('[data-slideshow-item]').attr('data-slideshow-item', 0);
                $('[data-slideshow-item] span').text(
                    `slide ${$('[data-slideshow-item]').length}`
                );
                $('[data-banner]').attr('data-banner', '0');
                $('.uk-dotnav [data-uk-slideshow-item]').attr(
                    'data-uk-slideshow-item',
                    '0'
                );
            }

            var mg = $('#rvs-uk-slide');
            mg.find('.uk-cover-background').remove();
            mg.find('.uk-slideshow-ghost').remove();

            var mgClone = mg.clone().get(0);
            mg.after(mgClone);
            mg.remove();

            setTimeout(function () {
                UIkit.slideshow(mgClone);

                if ($('[data-slideshow-item]').length == '1') {
                    $('.delete-slide').hide();
                    $('#BG_Slide').show();
                    $('.rv-Switchbanner').show();
                } else {
                    $('[data-slideshow-item]').first().trigger('click');
                }
            }, 200);
        });

        buttonSlide.click(function (e) {
            var KeySlide = $(this).attr('data-slideshow-item');
            var fb = parent.$('#frameBody').get(0).contentWindow;

            fb.$(
                '.uk-dotnav [data-uk-slideshow-item=' + KeySlide + ']'
            ).trigger('click');
            fb.$('.uk-dotnav [data-uk-slideshow-item]').removeClass(
                'uk-active'
            );
            fb.$(
                '.uk-dotnav [data-uk-slideshow-item=' + KeySlide + ']'
            ).addClass('uk-active');

            fb.$('[data-slideshow-item] #BG_Slide').hide();
            fb.$('[data-slideshow-item] .delete-slide').show();
            fb.$('[data-slideshow-item]').removeClass('uk-active');
            $(this).find('#BG_Slide').show();
            $(this).find('.delete-slide').hide();
            $(this).addClass('uk-active');
        });

        $('#countBanner').append(buttonSlide);
    };

    RVwys.BannerDesign.RegisRVSlide = function (dataNum) {
        var dataNum = dataNum ? dataNum : $('[data-slideshow-slide]').length;
        var mg = $('#rvs-uk-slide');
        mg.find('.uk-cover-background').remove();
        mg.find('.uk-slideshow-ghost').remove();
        mg.find('.uk-dotnav .uk-active').removeClass('uk-active');
        var mgClone = mg.clone();
        mg.after(mgClone);
        mg.remove();
        var UIkit = parent.UIkit;
        UIkit.slideshow(mgClone, {
            start: dataNum,
        });
    };

    //	Function Navigation

    RVwys.AjaxAddmenu = function (oThis) {
        var menu_type = oThis.attr('location-type');
        var menu_title = oThis.attr('menu-title');

        axiosAddMenu({
            location: menu_type,
            title: menu_title,
        }).then(function (response) {
            oThis.attr('menu-id', response.data);
            RVwys.uikit.showPanelNavgation(oThis);
        });
    };

    RVwys.AjaxSavemenu = function (JsonMenu) {
        axiosSaveMenu({
            menu_json: JsonMenu,
        }).then(async () => {
            parent.wex.menu.menu_tree = await wexAPIMenu.wexMenuTree();
            parent.console.pop.success({
                text: 'Save Success',
                delay: 5000,
            });
        });

        parent.RVwys.hidePanelAll();
    };

    RVwys.EvenMenu = function (obj) {
        $(
            '#selected_navigator li a.NavEdit,#selected_topmenu li:not(.disableTopmenu) a.NavEdit'
        ).click(function () {
            var oThis = $(this).parent();
            $('.uk-navbar .uk-active').removeClass('uk-active');
            oThis.addClass('uk-active');
            RVwys.uikit.showPanelNavgation(oThis);
        });

        $(
            '#selected_navigator ul li:not(.uk-parent),#selected_topmenu li:not(.disableTopmenu) '
        )
            .mouseenter(function () {
                //
                $(this).find('.removeMenu').show();
            })
            .mouseleave(function () {
                //
                $(this).find('.removeMenu').hide();
            });
    };

    RVwys.removeMenu = function (obj) {
        obj.find('.removeMenu').click(function () {
            var delMenu = $(this).parents('li').attr('menu-id');
            arr_deletemenu.push(delMenu);
            $('[menu-id=' + delMenu + ']').fadeOut();
        });
    };

    RVwys.SaveSortMenu = function (locationMenu) {
        var JsonMenu = [];
        var objJsonMenu = {};

        $.each(locationMenu, function (index, val) {
            index += 1;

            var arrSortMenu = [];
            var objSortMenu = {};

            //			$("."+val).find('ul.uk-navbar-nav').children().children('a.NavEdit').each(function(index){
            $(val)
                .find('ul.uk-navbar-nav,ul.uk-subnav')
                .children()
                .children('a.NavEdit')
                .each(function (index) {
                    index += 1;
                    var Menuid = $(this).parent().attr('menu-id');

                    objSortMenu = {
                        'menu-id': Menuid,
                        priority: index,
                    };

                    arrSortMenu.push(objSortMenu);

                    //			uk-parent
                    if ($(this).parent().hasClass('uk-parent')) {
                        var subMenu = $(this)
                            .parent()
                            .find('.uk-nav-navbar')
                            .children();

                        var arrSortSubMenu = [];
                        var objSortSubMenu = {};
                        subMenu.each(function (keySub) {
                            keySub = keySub + 1;
                            var subMenuid = $(this).attr('menu-id');

                            objSortSubMenu = {
                                'menu-id': subMenuid,
                                priority: keySub,
                            };
                            arrSortSubMenu.push(objSortSubMenu);

                            //			Submenu uk-nav-sub
                            if ($(this).find('ul').hasClass('uk-nav-sub')) {
                                var arrSortSubMenu2 = [];
                                var objSortSubMenu2 = {};
                                $(this).each(function (index) {
                                    var subMenu2 = $(this)
                                        .find('ul.uk-nav-sub')
                                        .children();
                                    var keySub2 = 1;
                                    //			SubMenu2
                                    subMenu2.each(function (index2) {
                                        var subMenuid2 =
                                            $(this).attr('menu-id');

                                        objSortSubMenu2 = {
                                            'menu-id': subMenuid2,
                                            priority: keySub2,
                                        };
                                        keySub2 = keySub2 + 1;
                                        arrSortSubMenu2.push(objSortSubMenu2);
                                    });
                                });

                                objSortSubMenu['submenu'] = arrSortSubMenu2;
                            }
                        });

                        objSortMenu['submenu'] = arrSortSubMenu;
                    }
                });
            objJsonMenu = {
                location: index,
                menu: arrSortMenu,
            };
            JsonMenu.push(objJsonMenu);
        });

        RVwys.AjaxSavemenu(JSON.stringify(JsonMenu));
        //
    };

    RVwys.UpdateIcon = function (obj) {
        var id = parent.$('.wys-navPropertie').attr('id');

        axiosUpdateMenu({
            type: 'icon',
            menu_id: id,
            icon: obj,
        }).then(result => {
            var fb = parent.$('#frameBody').get(0).contentWindow;
            var oNavMenu = fb
                .$('#selected_navigator,#selected_topmenu')
                .find(`li[menu-id="${result.data}"]`);
            oNavMenu.attr('menu-icon', obj);
            var oIcon = oNavMenu
                .children('.NavEdit')
                .children('span')
                .find('i')
                .first();
            var icon = oIcon.attr('class').split(' ')[1];
            oIcon.removeClass(icon).addClass(obj);
        });
    };

    RVwys.UISortMenu = function (obj) {
        var oNavbar = $('nav.uk-navbar');
        //		Start Sortable
        oNavbar.find('.uk-navbar-nav,.uk-nav-navbar,.uk-nav-sub').sortable({
            connectWith: '.uk-navbar-nav,.uk-nav-navbar,.uk-nav-sub:not(li)',
            placeholder: 'uk-icon-caret-down icon-red',
            opacity: '.5',
            appendTo: 'body',
            cancel: '.foreditmode',
            receive: function (e, ui) {
                if (ui.item.find('.dropdownLv2').has('li').length > 0) {
                    ui.sender.sortable('cancel');
                }
            },
            change: function (event, ui) {
                var NextUI = $(ui.placeholder).next().eq(0);
                var PrevUI = $(ui.placeholder).prev().eq(0);

                if (
                    !$(ui.item).is('[is-homepage="1"]') &&
                    !$(ui.item).is('.uk-parent') &&
                    NextUI.is('li')
                ) {
                    NextUI.addClass('uk-open');
                }

                $(ui.item).find('.dropdownUILv2').remove();
            },
            stop: function (event, ui) {
                oNavbar.find('li').removeClass('uk-open');
                var uiItem = $(ui.item);
                var oDropdown2 = uiItem.parent();
                var oDiv = uiItem.parent().parent('.uk-dropdown');
                var icaret = $('<i class="uk-icon-caret-down"></i>');
                var iRcaret = $('<i class="uk-icon-caret-right"></i>');

                if (oDiv.length) {
                    oDiv.parent().addClass('uk-parent').attr({
                        'data-uk-dropdown': '',
                        'aria-haspopup': 'true',
                        'aria-expanded': 'false',
                    });

                    if (
                        oDiv.parent().find('a').eq(0).has('.uk-icon-caret-down')
                            .length === 0
                    ) {
                        oDiv.parent().find('a').eq(0).append(icaret);
                    }

                    if (uiItem.find('.uk-dropdown')) {
                        uiItem.find('.uk-dropdown').remove();
                    }

                    if (uiItem.find('.dropdownLv2').length == 0) {
                        uiItem.append(
                            '<ul class="uk-nav-sub dropdownUILv2"></ul>'
                        );
                    }
                } else if (oDropdown2.hasClass('dropdownLv2')) {
                    if (
                        oDropdown2
                            .parent()
                            .find('a')
                            .eq(0)
                            .find('.uk-icon-caret-right').length == 0
                    ) {
                        oDropdown2.parent().find('a').eq(0).append(iRcaret);
                    }
                } else {
                    if (!uiItem.find('.uk-dropdown').length) {
                        //						alert(uiItem.find('.uk-dropdown').length);
                        uiItem.append(
                            '<div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top: 55px; left: 0px;"><ul class="uk-nav uk-nav-navbar dropdownop"></ul></div>'
                        );
                    }

                    if (uiItem.find('.dropdownLv2').length) {
                        //						uiItem.find('.uk-icon-caret-right').switchClass('uk-icon-caret-right','uk-icon-caret-down');
                        //						uiItem.find('.uk-dropdown-navbar').append($(this));
                        //						$(this).remove();
                    } else {
                    }
                }

                $('.dropdownLv2:empty')
                    .parent()
                    .find('.uk-icon-caret-right')
                    .remove();

                $('.uk-nav-navbar:empty')
                    .parent()
                    .parent()
                    .removeClass('uk-parent')
                    .find('.uk-icon-caret-down')
                    .remove();
            },
        });

        //End Sortable
    };

    RVwys.AddMenuSetting = function () {
        var countNavLeft = $('#selected_navigator .uk-float-left').find(
            '.js-left-nav,.js-right-nav'
        ).length;
        if (countNavLeft) {
            var oNavleft = $('#selected_navigator .uk-float-left')
                .find('.js-left-nav > ul,.js-right-nav > ul')
                .last();

            $(
                '#selected_navigator .uk-float-left > .js-left-nav,.uk-float-left > .js-right-nav'
            )
                .last()
                .append($('.rowAddmenuleft').html());

            $('.addMenuleft').click(function () {
                var Tagli = $(
                    `<li menu-id="" slug-id="" menu-title="Menu" menu-badge-style="" menu-badge-title="" menu-icon="" menu-target="" menu-url="" menu-type=""  location-type="1">
                        <a class="NavEdit" href="javascript:void(0)" target="_self" >
                            <span><i class="uk-icon"></i> Menu </span>
                            <div class="uk-badge uk-badge-transparent"></div>
                        </a>
                        <div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;">
                            <ul class="uk-nav uk-nav-navbar dropdownop"></ul>
                        </div>
                    </li>`
                );
                oNavleft.append(Tagli);
                Tagli.append($('.rowDeleteMenu').html());
                RVwys.EvenMenu(Tagli);
                RVwys.UISortMenu();
                RVwys.AjaxAddmenu(Tagli);
                RVwys.removeMenu(Tagli);
            });
        }

        var countNavRight = $('#selected_navigator .uk-float-right').find(
            '.js-left-nav,.js-right-nav'
        ).length;
        if (countNavRight) {
            var oNavright = $('#selected_navigator .uk-float-right')
                .find('.js-left-nav ul,.js-right-nav ul')
                .first();

            $(
                '#selected_navigator .uk-float-right > .js-left-nav,.uk-float-right > .js-right-nav'
            )
                .first()
                .prepend($('.rowAddmenuright').html());

            $('.addMenuright').click(function () {
                var Tagli = $(
                    `<li menu-id="" slug-id="" menu-title="Menu" menu-badge-style="" menu-badge-title="" menu-icon="" menu-target="" menu-url="" menu-type="" location-type="2">
                        <a class="NavEdit" href="javascript:void(0)" target="_self">
                            <span><i class="uk-icon"></i> Menu </span>
                            <div class="uk-badge uk-badge-transparent"></div>
                            </a>
                        <div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;">
                            <ul class="uk-nav uk-nav-navbar dropdownop"></ul>
                        </div>
                    </li>`
                );
                oNavright.prepend(Tagli);
                Tagli.append($('.rowDeleteMenu').html());
                RVwys.EvenMenu(Tagli);
                RVwys.UISortMenu();
                RVwys.AjaxAddmenu(Tagli);
                RVwys.removeMenu(Tagli);
            });
        }

        if ($('#selected_navigator #rvnav-center').length) {
            //			alert('center');
            //

            var oNavleft = $('#selected_navigator')
                .find('.js-left-nav > ul,.js-right-nav > ul')
                .last();

            $('#selected_navigator #rvnav-center').append(
                $('.rowAddmenuleft').html()
            );
            $('.addMenuleft').click(function () {
                var Tagli = $(
                    `<li menu-id="" slug-id="" menu-title="Menu" menu-badge-style="" menu-badge-title="" menu-icon="" menu-target="" menu-url="" menu-type=""  location-type="1">
                        <a class="NavEdit" href="javascript:void(0)" target="_self" >
                            <span><i class="uk-icon"></i> Menu </span>
                            <div class="uk-badge uk-badge-transparent"></div>
                        </a>
                        <div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;">
                            <ul class="uk-nav uk-nav-navbar dropdownop"></ul>
                        </div>
                    </li>`
                );
                oNavleft.append(Tagli);
                Tagli.append($('.rowDeleteMenu').html());
                RVwys.EvenMenu(Tagli);
                RVwys.UISortMenu();
                RVwys.AjaxAddmenu(Tagli);
                RVwys.removeMenu(Tagli);
            });

            var oNavright = $('#selected_navigator #rvnav-center')
                .find('.js-left-nav ul,.js-right-nav ul')
                .first();
            $('#selected_navigator #rvnav-center').prepend(
                $('.rowAddmenuright').html()
            );
            $('.addMenuright').click(function () {
                var Tagli = $(
                    `<li menu-id="" slug-id="" menu-title="Menu" menu-badge-style="" menu-badge-title="" menu-icon="" menu-target="" menu-url="" menu-type="" location-type="2">
                        <a class="NavEdit" href="javascript:void(0)" target="_self">
                            <span><i class="uk-icon"></i> Menu </span>
                        </a>
                        <div class="uk-dropdown uk-dropdown-navbar uk-dropdown-bottom" aria-hidden="true" tabindex="" style="top:55px; left: 0px;">
                            <ul class="uk-nav uk-nav-navbar dropdownop"></ul>
                        </div>
                    </li>`
                );
                oNavright.prepend(Tagli);
                Tagli.append($('.rowDeleteMenu').html());
                RVwys.EvenMenu(Tagli);
                RVwys.UISortMenu();
                RVwys.AjaxAddmenu(Tagli);
                RVwys.removeMenu(Tagli);
            });
        }

        $('.rowAddmenuleft,.rowAddmenuright').hide();
    };

    RVwys.DeleteMenu = function (menuID) {
        axiosDeleteMenu({
            type: 'Delete',
            menu_id: menuID,
        });
    };

    RVwys.MenuPreview = function () {
        /*	 overlaypanel = $('<div class="overlaymenu"></div>').css({
			   'background-color':'red',
			   'opacity':'0.0',
			   'position':'absolute',
			   'left':'0px',
			   'top':'0px',
			   'width':$('body').width(),
			   'height':$('body').height()
		   });

		   parent.$('body').prepend(overlaypanel);*/

        parent.$('.Nav-category:not(.rv-nav-normal)').hide();

        parent.$('#overlaymenu').click(function () {
            if (
                $('#selected_navigator').next($('#selected_headerbanner'))
                    .length
            ) {
                parent.$('.Nav-category:not(.overlay-top)').hide();
            } else {
                console.log(
                    $('#selected_navigator').next($('#selected_headerbanner'))
                        .length
                );

                parent.$('.Nav-category:not(.overlay-bottom)').hide();
            }
            parent.$('.overlaymenu').remove();
        });

        var hrefCssOld = $('#menuCss').attr('href');

        if ($('.selected_overlap').hasClass('overlap')) {
            parent.$('#overlap_onoff').prop('checked', true).trigger('change');
        }

        if ($('#selected_navigator').css('display') != 'none') {
            parent.$('#menu_onoff').prop('checked', true).trigger('change');
        }
        var showmenu = parent.$('#menu_onoff').prop('checked');

        parent.$('#navAlbumUikit .hvr-glow').click(function () {
            var idCss = $(this).parent().attr('menu');
            $('#menuCss').attr(
                'href',
                parent.wex.cdn.cdnURL +
                    '/service/html/menu/css/' +
                    idCss +
                    '.css'
            );

            parent.$('.overlaymenu').click(function (e) {
                parent.$('.btn-save-menuStyle').trigger('click');
                parent.$('.overlaymenu').remove();
            });
        });

        //		Cancel Menu Style
        parent.$('.btn-cancel-menuStyle').click(function () {
            parent.$('.wys-menuDesign').fadeOut();
            $('#menuCss').attr('href', hrefCssOld);

            if (showmenu == 'true') {
                parent.$('#menu_onoff').prop('checked', true).trigger('change');
            } else {
                parent
                    .$('#menu_onoff')
                    .prop('checked', false)
                    .trigger('change');
            }
        });

        //		Save Menu Style
        parent.$('.btn-save-menuStyle').click(function (e) {
            RVwys.HeaderDesign.SaveBanner(e);
            var overlaypanel = $(
                `<div class="overlaypanel">
                    <img class="loading" src="${parent.wex.url.WYS_IMG_URL}images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />
                </div>`
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });

            var idMenu = $('#menuCss')
                .attr('href')
                .match(/css\/(\d+)/);

            var page_id = parent
                .$('#frameBody')
                .contents()
                .find("input[name^='page_id']")
                .val();

            parent.$('body').append(overlaypanel);

            axiosSaveMenuStyle({
                page_id: page_id,
                menu_style: idMenu[1],
            }).then(response => {
                parent.RVwys.hidePanelAll();

                setTimeout(function () {
                    parent.$('.overlaypanel').remove();
                    parent.$('.overlaymenu').remove();
                }, 100);
            });
        });
    };

    RVwys.EventRemove = function () {
        var oNavbar = $('nav.uk-navbar');

        $('.overlaymenu').remove();
        parent.$('.overlaymenu').remove();
        //		ลบตัวรอก่อน Sort
        $('.dropdownLv2:empty').remove();
        $('.dropdownLv2').removeClass('dropdownLv2');
        $('.dropdownUILv2:empty').remove();
        $('.dropdownUILv2').removeClass('dropdownUILv2');
        $('#selected_navigator').find('.foreditmode').remove();
        $('#selected_navigator').find('li').first().removeClass('uk-active');
        $('#selected_navigator').removeAttr('style');
        $('#topmenu').removeAttr('style');
        //		$('#selected_navigator a[onclick^="return"]').removeAttr('onclick');
        $('#selected_navigator a[onclick^="return"]').attr(
            'onclick',
            'return true'
        );

        $('ul').removeClass('dropdownop');
        $('nav  ul').removeClass('navul');
        $('nav li').removeClass('uk-open');

        oNavbar.find('.ui-sortable').sortable('destroy');
        $('.NavEdit').unbind();
        $('.NavEdit').removeClass('NavEdit');

        if (arr_deletemenu.length != 0) {
            RVwys.DeleteMenu(arr_deletemenu);
        }

        $('.dropdownop').removeClass('dropdownop');
        $('.uk-dropdown > ul:empty').parent().remove();

        $('.NavManager').hide();
        $('.NavDesign').show();
    };
    //	End Function Navigation

    //	Function Topmenu
    RVwys.TopmenuPreview = function () {
        var overlaypanel = $('<div class="overlaytopmenu"></div>').css({
            'background-color': 'red',
            opacity: '0.0',
            position: 'absolute',
            left: '0px',
            top: '0px',
            width: $('body').width(),
            height: $('body').height(),
        });
        parent.$('body').prepend(overlaypanel);

        if ($('.top_login').css('display') == 'none') {
            parent.$('#login_onoff').prop('checked', false).trigger('change');
        } else {
            parent.$('#login_onoff').prop('checked', true).trigger('change');
        }

        var hrefCssOld = $('#topmenuCss').attr('href');
        var idCssOld = $('#topmenuCss').attr('href').match(/\d+/);

        var topmenuOld = $('#selected_topmenu').clone();
        var topmenuSite = $('#selected_topmenu top_nav').children('ul').clone();
        var logoFromWex = `<logo><a href="#" target="_parent"><img src="${parent.wex.site.logo}" alt="" style="max-height: 50px;"></a></logo>`;
        var topnav = $('#selected_header top_nav').clone();
        var logo = $('#selected_header logo').get(0)
            ? $('#selected_header logo').clone()
            : logoFromWex;
        var tel = $('#selected_topmenu tel').clone();

        //		PreviewTopmenu
        parent.$('#TopmenuAlbumUikit .hvr-glow').click(function (e) {
            //			var oRodata = $('<div>').html($(this).attr('data'));
            var oRodata = $($(this).attr('data'));
            var topmenucdn = oRodata.find('top_nav').replaceWith(topnav);
            oRodata.find('tel').replaceWith(tel);
            oRodata.find('logo').replaceWith(logo);

            /*if(!oRodata.find('logo')){
				oRodata = oRodata.find('.topmenu-minwidth').append(logo.css('display','none'));
//
			}*/

            topmenucdn.empty().append(topmenuSite);

            var topmenucdnfull = oRodata;

            RVwys.Brand.Event(topmenucdnfull);
            $('#selected_topmenu').replaceWith(topmenucdnfull);
            //			$('logo')
            //		Change Style

            var idCss = $(this).parent().attr('topmenu');
            $('#topmenuCss').attr(
                'href',
                parent.wex.cdn.cdnURL +
                    '/service/html/topmenu/css/' +
                    idCss +
                    '.css'
            );

            RVwys.regisSection(e, $('#selected_topmenu'));
        });

        parent.$('.overlaytopmenu').click(function () {
            parent.$('.btn-save-topmenu').trigger('click');
            parent.$('.overlaytopmenu').remove();
            parent.$('.wys-topmenuDesign').hide();
        });

        //		Save Topmenu
        parent.$('.btn-save-topmenu').click(function () {
            var overlaypanel = $(
                '<div class="overlaypanel">' +
                    '<img class="loading" src="' +
                    parent.wex.url.WYS_IMG_URL +
                    'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                    '</div>'
            ).css({
                width: $('body').width(),
                height: $('body').height(),
            });

            var idTopmenu = $('#topmenuCss')
                .attr('href')
                .match(/css\/(\d+)/);
            var page_id = parent
                .$('#frameBody')
                .contents()
                .find("input[name^='page_id']")
                .val();

            parent.$('body').append(overlaypanel);

            if (idTopmenu != null) {
                idTopmenu = idTopmenu[1];
                axiosSaveTopMenuStyle({
                    page_id: page_id,
                    topmenu_style: idTopmenu,
                }).then(response => {
                    console.log('response: ', response);
                    $('#topmenuCss').attr(
                        'href',
                        `/storage/myheader/topmenu/${idTopmenu}.css`
                    );
                });
            }

            RVwys.Brand.Event($('#selected_topmenu'));

            parent.console.pop.success({
                text: 'Save Success',
                delay: 5000,
            });
            parent.RVwys.hidePanelAll();
            parent.$('.overlaypanel').remove();
            parent.$('.overlaytopmenu').remove();
        });

        //		Reset Topmenu
        parent.$('.btn-reset-topmenu').click(function () {
            parent.$('.wys-topmenuDesign').fadeOut();
            $('#selected_topmenu').replaceWith(topmenuOld);
            $('#topmenuCss').attr('href', hrefCssOld);
        });
    };

    RVwys.hideLoginMenu = function (isTop) {
        $.ajax({
            type: 'POST',
            url: parent.wex.url.baseUrl + '/admin/wysiwyg/update/hideLoginMenu',
            data: {
                show_menu: isTop,
                _token: $('meta[name="csrf-token"]').attr('content'),
            },
            success: function (data) {},
        });
    };
    //	End Function Topmenu

    //	Function HeaderDesign

    RVwys.Custombanner.resetBanner = function (e) {
        var UI = parent.UIkit;

        oncancel = function () {
            modal.hide();
        };

        var onInsert = function () {
            $.ajax({
                type: 'POST',
                url:
                    parent.wex.url.baseUrl +
                    '/admin/wysiwyg/update/resetHeader',
                data: {
                    slug_id: parent.$('#slug_id').val(),
                    _token: $('meta[name="csrf-token"]').attr('content'),
                },
                success: function (data) {
                    var isData = $('<div>').html(data);
                    $('#selected_headerbanner').replaceWith(
                        isData.find('#selected_headerbanner')
                    );
                    $('#selected_headerbanner')
                        .find('.RVWYSIWYGAREA')
                        .removeClass('RVWYSIWYGAREA');
                    parent.$('#isMasterHeader').val('0');
                    RVwys.Custombanner.EventBanner(e);
                    RVwys.HeaderDesign.RegisHeader(e);
                },
            });

            modal.hide();
        };

        var modal = UI.modal.dialog(
            [
                '<div class="uk-margin uk-modal-header"><h2>' +
                    rvLang('Reset Banner') +
                    '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                '<div class="uk-margin uk-modal-content"><span>Reset Banner to default?</span></div>',
                '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                    rvLang('Yes') +
                    '</button>',
                '<button class="uk-button js-modal-confirm-cancel">' +
                    rvLang('No') +
                    '</button></div>',
            ].join('')
        );

        modal.element
            .find('.js-modal-confirm-cancel')
            .on('click', function () {
                oncancel();
            })
            .end()
            .find('.uk-button-success')
            .on('click', function () {
                onInsert();
            });

        modal.show();
    };

    RVwys.Custombanner.EventBanner = function (e) {
        var currentPage = parent.$('#cmsCurrent').text();

        if (parent.$('#isMasterHeader').val() == '0') {
            var overlaypanel = $('<div class="overlayCustomBanner"></div>').css(
                {
                    position: 'absolute',
                    left: '0px',
                    top: '0px',
                    zIndex: '5',
                    display: 'none',
                    width: $('#selected_headerbanner').width(),
                    height: $('#selected_headerbanner').height(),
                }
            );
            var overlaypanelCustom = $(
                '<div class="layCustomBanner"></div>'
            ).css({
                'background-color': 'red',
                opacity: '0.0',
                position: 'absolute',
                left: '0px',
                top: '0px',
                zIndex: '5',

                width: $('#selected_headerbanner').width(),
                height: $('#selected_headerbanner').height(),
            });
            var btnCustom = $(
                '<a class="uk-button uk-button-primary" id="editCustombanner" style="position: absolute;top: 0;right: 0;z-index: 10;"> Custom this banner?</a>'
            );
            if ($('#CustomBannerFigure').length == 0) {
                $('#selected_headerbanner .mg>div').wrap(
                    '<figure id="CustomBannerFigure" class="rv-banner-overlay uk-overlay-hover">'
                );
                $('#CustomBannerFigure').append(overlaypanel);
                $('#CustomBannerFigure').append(
                    parent.$('#CustomBannerFig').clone()
                );
            }

            //						   Condition Custom Menu Overlay
            if ($('.selected_overlap').hasClass('overlap')) {
                if (
                    $('#selected_headerbanner').prev().is('#selected_navigator')
                ) {
                    $('#CustomBannerFig')
                        .css('top', $('#selected_navigator').height())
                        .show();
                }
            } else {
                $('#CustomBannerFig').removeAttr('style');
            }
            var menuCustom = $('li[menu-current-page="1"]').attr('menu-level');
            if (menuCustom == '2' || menuCustom == '3') {
                $('#keyWordCustom').text(
                    'Header Banner in this page is Inherited from parent page.'
                );
            } else if (parent.$('#isType').val() == 'post') {
                $('#keyWordCustom').text(
                    'Header Banner in this page is Inherited from blog main category.'
                );
            }

            $('.btnCustom,#editCustombanner').click(function () {
                //							setStatus Banner
                parent.window.isBanner = true;

                if (
                    $('#selected_headerbanner .editable_area').is(
                        '#editable_area_content-h'
                    )
                ) {
                    parent.isCusHeader
                        ? RVwys.sortHeader()
                        : RVwys.uikit.blockprop.HeaderBanner();

                    parent.$('#showdesign').trigger('click');
                }

                $('.overlayCustomBanner').remove();
                $('#CustomBannerFig').remove();
                $('#selected_headerbanner').unbind('mouseenter');
            });

            $('.hideCustombanner').click(function () {
                $('#selected_headerbanner .mg').append(btnCustom);
                $('#selected_headerbanner .mg').append(overlaypanelCustom);
                $('.overlayCustomBanner').remove();
                $('#CustomBannerFig').remove();
            });

            if ($('#editCustombanner')) {
                $('#editCustombanner, .layCustomBanner').show();
            }

            $('#editCustombanner').click(function () {
                $('.layCustomBanner').remove();
                $('#editCustombanner').remove();
            });

            $('#selected_headerbanner')
                .on('mouseenter', function () {
                    $('.overlayCustomBanner').show();
                    $('#CustomBannerFigure')
                        .addClass('rv-banner-overlay-hover')
                        .removeClass('rv-banner-overlay');
                })
                .mouseleave(function () {
                    $('#CustomBannerFigure')
                        .addClass('rv-banner-overlay')
                        .removeClass('rv-banner-overlay-hover');
                    $(
                        '.overlayCustomBanner, .layCustomBanner, #editCustombanner'
                    ).hide();
                });
        }
    };

    RVwys.Custombanner.EventClickCustom = function () {
        if ($('#selected_headerbanner').hasClass('uk-hidden')) {
            parent.$('#banner_onoff').prop('checked', true).trigger('change');
        }

        RVwys.uikit.blockprop.HeaderBanner();
        RVwys.setScollPostionFormDesign('setBanner');
    };

    RVwys.Custombanner.EventClickDesign = function (oThis) {
        parent.$('.wys-panel').hide();
        parent.isCusHeader = $(oThis).hasClass('SortHeader');

        if ($('#selected_headerbanner').hasClass('uk-hidden')) {
            parent.$('#banner_onoff').prop('checked', true).trigger('change');
            parent.$('#NoBanner').addClass('disabled');
        }

        if (
            parent.$('#isMasterHeader').val() == '0' &&
            parent.window.isBanner == false
        ) {
            var UI = parent.UIkit;
            var oncancel = function () {
                modal.hide();
            };

            var onInsert = function (e) {
                parent.window.isBanner = true;
                $('.btnCustom').trigger('click');
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>Custom Banner</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang(
                            'Header Banner in this page is Inherited from parent page.'
                        ) +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Custom this banner?') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">Cancel</button>',
                    '</div>',
                    '</div>',
                ].join('')
            );
            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        } else {
            if (!parent.isCusHeader) {
                RVwys.uikit.blockprop.HeaderBanner();
            } else {
                RVwys.sortHeader();
            }
        }
    };

    RVwys.setScollPostionFormDesign = function (oScroll) {
        var getScroll;
        switch (oScroll) {
            case 'setHeader':
                getScroll = '0';
                break;
            case 'setNav':
                getScroll = $('#selected_navigator').offset().top - 200;
                break;
            case 'setTop':
                getScroll = $('#selected_topmenu').offset().top;
                break;
            case 'setFooter':
                getScroll = $('#selected_footer').offset().top;
                break;
            case 'setBanner':
                getScroll = $('#selected_headerbanner').offset().top;
                break;
            case 'setSidebar':
                getScroll = $('#selected_body').offset().top;
                break;
            default:
                getScroll = '';
                break;
            // code block
        }

        $('html, body').animate(
            {
                scrollTop: getScroll,
            },
            1000
        );
    };

    RVwys.HeaderDesign.HeaderPreview = function () {
        var overlaypanel = $('<div class="overlayheader"></div>').css({
            'background-color': 'red',
            opacity: '0.0',
            position: 'absolute',
            left: '0px',
            top: '0px',
            width: $('body').width(),
            height: $('body').height(),
        });
        parent.$('body').prepend(overlaypanel);
        parent.$('.header-category:not(.rv-head-hero)').hide();
        var hrefCssOld = $('#headerCss').attr('href');
        var idCssOld = $('#headerCss').attr('href').match(/\d+/);
        var HeaderOld = $('#selected_header')
            .clone()
            .attr('id', 'selected_header_old');
        var topmenuSite = $('#selected_topmenu top_nav').children('ul').clone();
        var menuSiteLeft = $('#selected_navigator .js-left-nav')
            .children('ul')
            .clone();
        var menuSiteRight = $('#selected_navigator .js-right-nav')
            .children('ul')
            .clone();
        parent.$('#headerAlbumUikit .hvr-glow').click(function (e) {
            RVwys.setScollPostionFormDesign('setHeader');
            //			var bannerSite
            parent.$('.header-active').removeClass('header-active');
            $(this).children().addClass('header-active');
            var oRodata = $('<div>').html($(this).attr('data'));
            var idCss = $(this).parent().attr('header');
            var topmenucdn = oRodata
                .find('#selected_topmenu top_nav')
                .children('ul');
            topmenucdn.replaceWith(topmenuSite);
            var menucdnLeft = oRodata
                .find('#selected_navigator .js-left-nav')
                .children('ul');
            menucdnLeft.replaceWith(menuSiteLeft);
            var menucdnRight = oRodata
                .find('#selected_navigator .js-right-nav')
                .children('ul');
            menucdnRight.replaceWith(menuSiteRight);
            var headercdn = oRodata.find(
                '#selected_headerbanner #rvs-uk-slide'
            );
            $('#selected_header').empty();
            $('#selected_header').append(oRodata.html()).show('slow');
            var CssHerf = {
                headerCss: 'header',
                menuCss: 'menu',
                topmenuCss: 'topmenu',
            };
            $.each(CssHerf, function (id, val) {
                if (id == 'menuCss') {
                    $('#' + id).attr(
                        'href',
                        parent.wex.cdn.cdnURL +
                            '/service/html/' +
                            val +
                            '/css/' +
                            idCss +
                            '-main.css'
                    );
                } else {
                    $('#' + id).attr(
                        'href',
                        parent.wex.cdn.cdnURL +
                            '/service/html/' +
                            val +
                            '/css/' +
                            idCss +
                            '.css'
                    );
                }
            });
            parent.$('.overlayheader').bind('click', function () {
                parent.$('.button-save-header').trigger('click');
                parent.$('.overlayheader').remove();
            });
            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.BannerDesign.EventEditSlide();
            RVwys.Brand.Event();
            RVwys.Custombanner.EventBanner();
        });

        parent
            .$('.wys-rowHeader #bannerAlbumUikit .hvr-glow')
            .click(function (e) {
                var oRodata = $('<div>').html($(this).attr('data'));
                var idCss = $(this).parent().attr('banner');
                $('.uk-slideshow ul>li').replaceWith(oRodata);

                RVwys.HeaderDesign.RegisHeader(e);
                RVwys.Brand.Event();
                RVwys.Custombanner.EventBanner();
            });

        parent.$('.button-cancel-header').click(function (e) {
            $('#selected_header').replaceWith(
                HeaderOld.clone().attr('id', 'selected_header')
            );
            $('.RVWYSIWYGAREA').removeClass('RVWYSIWYGAREA');

            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.BannerDesign.EventEditSlide();
            RVwys.Brand.Event();

            var CssHerf = {
                headerCss: 'header',
                menuCss: 'menu',
                topmenuCss: 'topmenu',
            };
            $.each(CssHerf, function (id, val) {
                $('#' + id).attr(
                    'href',
                    '/storage/myheader/' +
                        val +
                        '/' +
                        idCssOld +
                        '-' +
                        val +
                        '.css'
                );
            });

            //			parent.$('.wys-rowHeader').fadeOut();
        });

        parent.$('.button-save-header').click(function (e) {
            RVwys.HeaderDesign.SaveHeader(e);
        });

        parent.$('.overlayheader').click(function () {
            parent.$('.wys-rowHeader').hide();
            parent.$('.overlayheader').remove();
        });
    };

    RVwys.HeaderDesign.SaveHeader = function (e) {
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });
        var head_content = $('#selected_header').clone();
        var arr_cdn = head_content.find(
            'img[src*="' + parent.wex.cdn.cdnURL + +'"]'
        );
        var page_id = $("input[name^='page_id']").val();
        var bg_img = head_content.find('.jsheaderimg');
        var arr_bg = bg_img.css('background-image');
        var array_src = [];
        if (bg_img.length > 0) {
            arr_bg = arr_bg
                .replace('url(', '')
                .replace(')', '')
                .replace(/\"/gi, '');
            array_src.push(arr_bg);
        }
        var style = parent.$('.header-active').parent().parent().attr('header');
        arr_cdn.each(function () {
            array_src.push($(this).get(0).currentSrc);
        });
        //

        head_content.find('logo').html('[[LOGO]]');
        head_content.find('logo_mobile').html('[[LOGO_MOBILE]]');
        head_content.find('tel').html('[[TEL]]');
        head_content.find('#selected_topmenu top_nav').html('[[TOP_NAV]]');
        head_content
            .find('#selected_navigator .js-right-nav')
            .html('[[RIGHT_NAV]]');
        head_content
            .find('#selected_navigator .js-left-nav')
            .html('[[LEFT_NAV]]');
        head_content.find('.mgActive').removeClass('mgActive');
        head_content.find('.navMenu-blockMainSetting').remove();
        head_content.find('.RVWYSIWYGAREA').removeAttr('data-ph');
        head_content.find('.RVWYSIWYGAREA').removeAttr('id');
        head_content
            .find('.RVWYSIWYGAREA')
            .removeClass('RVWYSIWYGAREA editorCurrent areaCustom');
        head_content.find('.uk-slideshow').removeAttr('style');
        head_content.find('.uk-cover-background').remove();
        head_content.find('.SlideProperty').remove();
        head_content.find('.uk-navbar').unwrap();
        head_content.find('.uk-cover-background').remove();
        //		Custom Banner
        head_content.find('#CustomBannerFig').remove();
        head_content.find('.overlayCustomBanner').remove();
        head_content.find('#CustomBannerFigure>.uk-container').unwrap();

        var head_content_view = head_content.clone();
        head_content_view.find('.RVWYSIWYGAREA').removeAttr('data-ph');
        head_content_view.find('.RVWYSIWYGAREA').removeAttr('id');
        head_content_view
            .find('.RVWYSIWYGAREA')
            .removeClass('RVWYSIWYGAREA editorCurrent areaCustom');
        head_content_view
            .find('[contenteditable]')
            .removeAttr('contenteditable');
        head_content_view.find('.mgActive').removeClass('mgActive');
        head_content_view.find('.navMenu-blockMainSetting').remove();
        head_content_view.find('.blockTools').remove();
        head_content_view.find('.uk-cover-background').remove();
        head_content_view.find('.SlideProperty').remove();
        head_content_view.find('.uk-navbar').unwrap();
        head_content_view.find('.uk-cover-background').remove();
        parent.$('body').append(overlaypanel);

        axiosSaveHeaderStyle({
            page_id: page_id,
            header_style: style,
            menu_style: style,
            topmenu_style: style,
            content_edit: head_content.html(),
            content_view: head_content_view.html(),
            cdn: array_src,
        }).then(() => {
            $('#BannerHero').toggle($('#editable_area_content-s').get(0));

            parent.$('.overlayheader').remove();
            parent.$('.overlaypanel').remove();
            parent.RVwys.hidePanelAll();
        });
    };

    RVwys.HeaderDesign.HeaderBannerPreview = function () {
        $('#selected_headerbanner .editable_area').is(
            '#editable_area_content-h'
        )
            ? parent.$('.banner_hero').trigger('click').focus()
            : parent.$('.banner_slide').trigger('click').focus();

        var overlaypanel = $('<div class="overlayheader"></div>').css({
            'background-color': 'red',
            opacity: '0.0',
            position: 'absolute',
            left: '0px',
            top: '0px',
            width: $('body').width(),
            height: $('body').height(),
        });
        parent.$('body').prepend(overlaypanel);

        var hrefCssOld = $('#headerCss').attr('href');
        var idCssOld = $('#headerCss').attr('href').match(/\d+/);
        var HeaderOld = $('#selected_header')
            .clone()
            .attr('id', 'selected_header_old');
        var topmenuSite = $('#selected_topmenu top_nav').children('ul').clone();
        var menuSiteLeft = $('#selected_navigator .js-left-nav')
            .children('ul')
            .clone();
        var menuSiteRight = $('#selected_navigator .js-right-nav')
            .children('ul')
            .clone();
        var i = 0;
        parent.$('#bannerAlbumUikit .hvr-glow').click(function (e) {
            parent.$('.banner-active').removeClass('banner-active');
            $(this).children().addClass('banner-active');
            i++;
        });
        parent.$('.button-cancel-headerBanner').click(function (e) {
            $('#selected_header').replaceWith(
                HeaderOld.clone().attr('id', 'selected_header')
            );
            $('.RVWYSIWYGAREA').removeClass('RVWYSIWYGAREA');
            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.BannerDesign.EventEditSlide();
            RVwys.Brand.Event();
            var CssHerf = {
                headerCss: 'header',
                menuCss: 'menu',
                topmenuCss: 'topmenu',
            };
            $.each(CssHerf, function (id, val) {
                $('#' + id).attr(
                    'href',
                    '/storage/myheader/' +
                        val +
                        '/' +
                        idCssOld +
                        '-' +
                        val +
                        '.css'
                );
            });
        });

        parent.$('.overlayheader').click(function () {
            if (i > 0) {
                RVwys.HeaderDesign.SaveBanner();
            }

            parent.$('.wys-rowHeaderBanner').hide();
            parent.$('.overlayheader').remove();
        });
    };

    RVwys.HeaderDesign.RegisHeader = function (e) {
        var bms = $('#blockMainSetting');
        setTimeout(function () {
            var i = 0;

            $("#selected_header .editable_area [contenteditable='true']").each(
                function () {
                    if (!$(this).hasClass('RVWYSIWYGAREA')) {
                        var rvsb_design_block = RVwys.getParentByClass(
                            $(this),
                            'rvsb_design_block'
                        );
                        if (
                            !rvsb_design_block
                                .find('.navMenu-blockMainSetting')
                                .get(0)
                        ) {
                            rvsb_design_block.prepend(bms.html());
                        }

                        var idpref = $.md5(String(e.timeStamp));
                        var id = 'editable_area_custom' + idpref + i;
                        i++;
                        $(this)
                            .attr({
                                id: id,
                                'data-ph':
                                    'Editable Area. Backspace tab to remove this block.',
                            })
                            .addClass('RVWYSIWYGAREA editorCurrent areaCustom');
                        var edit = $('#' + id);
                        RVwys.EditorByClass(edit, 'notfocus');
                        var oMG = $('#' + id).closest('.mg');

                        RVwys.UIgridSortable(oMG);

                        oMG.mousedown(function () {
                            RVwys.eventClickblock($(this));
                        });
                    }
                }
            );

            setTimeout(function () {
                RVwys.currentEditor = document;
            }, 100);
        }, 500);
    };

    RVwys.HeaderDesign.SaveBanner = function () {
        var overlaypanel = $(
            '<div class="overlaypanel">' +
                '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" />' +
                '</div>'
        ).css({
            width: $('body').width(),
            height: $('body').height(),
        });

        //		var banner_content	= fb.$('#selected_header ul.uk-slideshow').clone();
        var head_content = $('#selected_header').clone();
        var arr_cdn = head_content.find(
            'img[src*="' + parent.wex.cdn.cdnURL + '"]'
        );

        var array_src = [];

        arr_cdn.each(function () {
            array_src.push($(this).get(0).currentSrc);
        });

        var head_content_edit =
            RVwys.save.removeEle.headerEditmode(head_content);
        head_content_edit =
            RVwys.save.removeClass.headerEditmode(head_content_edit);
        head_content_edit =
            RVwys.save.replaceEle.headerEditmode(head_content_edit);
        head_content_edit =
            RVwys.save.replaceTxt.headerEditmode(head_content_edit);

        var head_content_view =
            RVwys.save.removeEle.headerViewmode(head_content);
        head_content_view =
            RVwys.save.removeClass.headerViewmode(head_content_view);
        head_content_view =
            RVwys.save.replaceEle.headerViewmode(head_content_view);
        head_content_view =
            RVwys.save.replaceTxt.headerViewmode(head_content_view);

        head_content_edit = RVwys.save.encodeHTMLentities(head_content_edit);
        head_content_view = RVwys.save.encodeHTMLentities(head_content_view);

        parent.$('body').append(overlaypanel);
        axiosSaveSite({
            savetype: 'header',
            slug_id: parent.$('#slug_id').val(),
            header_content_view: head_content_view,
            header_content_edit: head_content_edit,
            cdn: array_src,
        }).then(result => {
            parent.console.pop.success({
                text: 'Save Banner Success',
                delay: 5000,
            });

            parent.$('.overlaypanel').remove();
        });

        parent.$('.overlaybanner').remove();
    };

    //	End Function HeaderDesign

    // Function Beand
    RVwys.Brand.Event = function (elem = $('body')) {
        parent.$('#LinkLogo').prop('checked', $('logo a').is('[href]'));
        parent.$('#LinkTel').prop('checked', $('tel').parent().is('[href]'));

        elem.find('logo img').click(function (e) {
            e.preventDefault();

            RVwys.Brand.setCurrentLogoImage();
            RVwys.uikit.blockprop.Brand();
        });

        parent.$('#LinkLogo').change(function (e, wasTriggered) {
            window.eventBrand = !wasTriggered && true;
            if (!$(this).is(':checked')) {
                $('logo a').attr('href', '');
            }
        });

        $('#contactFooter,#selected_topmenu tel').click(function () {
            RVwys.uikit.blockprop.Brand();
        });
    };

    RVwys.FindElement = function (Elem) {
        return $(Elem).get(0)
            ? $(Elem)
            : $('#frameBody').get(0).contentWindow.$(Elem);
    };

    RVwys.Brand.Setting = function (e) {
        RVwys.Brand.setCurrentLogoImage();

        parent.$('#titleSite').val(parent.$('#sitebrand').val());
        parent.$('.tel').val(RVwys.FindElement('#selected_header tel').text());

        parent.$('.email').val(RVwys.FindElement('#emailContactFooter').text());
        parent
            .$('.contactTitle')
            .val(RVwys.FindElement('#titleContact').text());
        parent
            .$('.address')
            .val(RVwys.FindElement('#addressContactFooter').text());

        var vLogo = $('logo img').attr('src');
        var vTitle = parent.$('#titleSite').val();
        var vTel = parent.$('.tel').val();
        var vEmail = parent.$('.email').val();
        var vTitleaddress = parent.$('.contactTitle').val();
        var vAddress = parent.$('.address').val();
        var overlaypanel = $('<div class="overlaybrand"></div>').css({
            'background-color': 'red',
            opacity: '0.0',
            position: 'absolute',
            left: '0px',
            top: '0px',
            zIndex: '99',
            width: $('body').width(),
            height: $('body').height(),
        });
        parent.$('body').prepend(overlaypanel);
        parent.$('.overlaybrand').click(function () {
            RVwys.Brand.save();
        });

        parent
            .$('.wys-rowBrand .uk-icon-close')
            .unbind('click')
            .click(function () {
                $(this).closest('.wys-panel,.wys-panels').hide();

                RVwys.Brand.save();
            });

        parent
            .$('#ResetBrandCustom')
            .unbind('click')
            .click(function () {
                parent.$('#titleSite').val(vTitle);
                parent.$('title').text(vTitle);

                parent.$('.tel').val(vTel);
                $('tel').text(vTel);

                parent
                    .$('.section-logo')
                    .css(
                        'background',
                        'url(' + vLogo + ') no-repeat 50% / contain'
                    );
                $('logo img').attr('src', vLogo);

                parent.$('.email').val(vEmail);
                $('email').text(vEmail);

                parent.$('.contactTitle').val(vTitleaddress);
                $('#titleContact').text(vTitleaddress);

                parent.$('.address').val(vAddress);
                $('#addressContactFooter').text(vAddress);
            });

        parent.$('#titleSite').keyup(function () {
            setTimeout(function () {
                parent.$('#sitebrand').val(parent.$('#titleSite').val());
            }, 50);
        });
    };

    RVwys.Brand.setCurrentLogoImage = function () {
        var logoUrl = parent.wex.site.logo;
        console.log('setCurrentLogoImage = ', logoUrl);

        parent
            .$('#frameBody')
            .contents()
            .find('.rv_logo img')
            .attr('src', logoUrl);

        parent
            .$('.section-logo')
            .css('background', 'url(' + logoUrl + ') no-repeat 50% / contain');
    };

    RVwys.Brand.save = function () {
        parent.$('.wys-rowBrand ').hide();
        var title = parent.$('#titleSite').val();
        var linktohomepage = '1';
        if (!parent.$('#LinkLogo').is(':checked')) {
            linktohomepage = '0';
        }
        var sitebrand = parent.$('#titleSite').val();
        var logo = $('logo img').attr('src');
        var urlreg = null;

        if (typeof logo !== 'undefined') {
            urlreg = logo.match(/logo.*/);
        }

        if (urlreg != null) {
            var urlregV = urlreg[0].replace(/\?v=[0-9a-zA-Z]*/, '');
            var logo_mobile = urlregV.replace('logo', 'logo-mobile');
        }

        var tel = parent.$('.tel').val();
        var email = parent.$('.email').val();
        var titlecontact = parent.$('.contactTitle').val();
        var address = parent.$('.address').val();

        //    Edit Frame layout

        if (window.eventBrand) {
            axiosSaveSettingBrand({
                logo: urlregV,
                logo_mobile: logo_mobile,
                tel: tel,
                linktohomepage: linktohomepage,
                sitebrand: sitebrand,
                email: email,
                titlecontact: titlecontact,
                address: address,
            })
                .then(result => {
                    parent.console.pop.success({
                        text: result.data.messages,
                        delay: 5000,
                    });

                    parent.$('.overlaybrand').remove();
                    $('.overlaypanel').remove();
                    window.eventBrand = false;
                })
                .catch(err => {
                    parent.console.error.success({
                        text: err.data.messages,
                        delay: 5000,
                    });
                });
        } else {
            parent.$('.overlaybrand').remove();
            window.eventBrand = false;
        }
    };

    RVwys.LogoUpload = function (input) {
        var fileType = ['.jpg', '.jpeg', '.bmp', '.gif', '.png'];
        var pat = new RegExp('(' + fileType.join('|') + ')$', 'img');
        var isFileType = pat.exec($(input).val());
        if (!isFileType) {
            var UI = parent.UIkit;
            var onInsert = function (e) {
                $('#imedit-upload').val('');
                parent.$('#imedit-upload').val('');
                modal.hide();
            };
            var options = {
                bgclose: false,
                keyboard: false,
                modal: false,
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Upload image') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang('file type not support.') +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Ok') +
                        '</button>',
                    '</div>',
                ].join(''),
                options
            );
            modal.element.find('.uk-button-success').on('click', function () {
                onInsert();
            });
            modal.show();
            $(input).val('');
            return false;
        }
        var sectionActive = $('#frameBody').get(0).contentWindow.$('logo img');

        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var getThis = $(this);
            reader.onload = function (e) {
                $(input).val('');
                var image = new Image();
                image.src = e.target.result;

                image.onload = function () {
                    // access image size here

                    $('.overlaypanel').remove();
                    if (this.width > 1601) {
                        var scale = 1600;
                        var ratio = RVwys.imagemanager.getRatioThumbnail(
                            this,
                            scale - 600
                        );
                        var canvas = document.createElement('canvas');
                        canvas.width = this.width * ratio;
                        canvas.height = this.height * ratio;
                        var ctx = canvas.getContext('2d');
                        ctx.scale(
                            scale / canvas.width,
                            (this.height * ratio) / canvas.height
                        );
                        ctx.drawImage(this, 0, 0, scale, this.height * ratio);
                        var dataURL = canvas.toDataURL('image/' + isFileType);
                    } else {
                        var canvas = document.createElement('canvas');
                        canvas.width = this.width;
                        canvas.height = this.height;
                        var ctx = canvas.getContext('2d');
                        ctx.drawImage(this, 0, 0, this.width, this.height);
                        var dataURL = canvas.toDataURL('image/' + isFileType);
                    }
                    // upload
                    var overlaypanel = $(
                        '<div class="overlaypanel"><p class="progressFB">' +
                            rvLang('copy to My image') +
                            '</p></div>'
                    ).css({
                        width: $('body').width(),
                        height: $('body').height(),
                    });
                    $('body').prepend(overlaypanel);

                    var canvasThumb = document.createElement('canvas');
                    var scale = 115;
                    var ratio = RVwys.imagemanager.getRatioThumbnail(
                        this,
                        scale
                    );
                    canvasThumb.width = this.width * ratio;
                    canvasThumb.height = this.height * ratio;
                    var ctxcanvasThumb = canvasThumb.getContext('2d');
                    ctxcanvasThumb.drawImage(
                        this,
                        0,
                        0,
                        scale,
                        this.height * ratio
                    );
                    var thumbnail = canvasThumb.toDataURL('image/' + imageType);
                    $(canvasThumb).remove();

                    var imageType = dataURL
                        .replace(/^data\:image\//gim, '')
                        .replace(/\;base64(.*)/gim, '');
                    if (this.src.match(/^data:image/)) {
                        var d = new Date();
                        var n = d.getTime();
                        var imageURL = '';
                        var imageName = 'logo.' + imageType;
                        var imageNamemobile = 'logo-mobile.' + imageType;
                    }
                    var sendImage = {
                        send: {
                            data: dataURL,
                            thumnail: thumbnail,
                            imageURL: imageURL,
                            override: true,
                            imageName: imageName,
                            imageType: imageType,
                            tagFolder: '',
                        },
                    };

                    RVwys.imagemanager.uploadImage(sendImage, function (URL) {
                        console.log(
                            'fn: RVwys.imagemanager.uploadImage(sendImage)'
                        );
                        var d = new Date();

                        var n = d.getTime();
                        //			        			alert(imageName);
                        var imageUrl = URL + '?v=' + n;
                        // display them
                        sectionActive.attr('src', URL + '?v=' + n);
                        parent
                            .$('.section-logo')
                            .css(
                                'background',
                                'url(' + imageUrl + ') no-repeat 50% / contain'
                            );

                        parent.wex.site.logo = imageUrl;
                        parent.wex.site.logo_mobile = imageUrl;
                    });

                    var sendImagemobile = {
                        send: {
                            data: dataURL,
                            thumnail: thumbnail,
                            imageURL: imageURL,
                            override: true,
                            imageName: imageNamemobile,
                            imageType: imageType,
                            tagFolder: '',
                        },
                    };

                    RVwys.imagemanager.uploadImage(
                        sendImagemobile,
                        function (URL) {}
                    );
                };
            };
            reader.readAsDataURL(input.files[0]);
        } else {
            swal("Sorry - you're browser doesn't support the FileReader API");
        }
    };

    // End Function Brand

    //	Navigation Properties
    RVwys.uikit.SelectPageNavigation = async function (menuType = '1', oSlug) {
        parent.$('#Navpage').html('');
        // menuType request  0= bookmark , 1 = page , 2 = post ,3 = system

        var isBookmark, isPage, isUrl;

        switch (menuType) {
            case '0':
                var arrbookmark = $('#frameBody')
                    .get(0)
                    .contentWindow.$('bookmark');

                isBookmark = true;
                isPage = false;
                isUrl = false;
                $.each(arrbookmark, function () {
                    var id = $(this).attr('id');
                    var oBookmark = $(`<option value="${id}"> #${id}</option>`);

                    $('#NavBookmark').html('');
                    $('#NavBookmark').append(oBookmark);
                });

                break;

            case '1':
            case '3':
                isBookmark = false;
                isPage = true;
                isUrl = false;

                var dataPage = parent.wex.page.page_tree;

                dataPage = dataPage.filter(function (value, index) {
                    return value.menu_type != 'externalmenu';
                });

                RVwys.setDataToSelectionPage(dataPage);

                parent
                    .$('#Navpage option')
                    .filter("[id='" + oSlug + "']")
                    .prop('selected', true);
                break;
            case '2':
                isBookmark = false;
                isPage = true;
                isUrl = false;

                /*
                 * TODO: Refactoring API WEX.BLOG - @Netway-Warithar
                 */
                // var dataPost = await axiosAPIBlog.axiosAPIBlogList();
                // var dataCategory = await axiosAPIBlog.axiosAPIBlogCategoryList();

                const dataPost = wex.blog.blog_lists;
                const dataCategory = wex.blog.blog_listscategory;

                RVwys.setDataToSelectionBlog(dataCategory, dataPost);
                parent
                    .$('#Navpage option')
                    .filter("[id='" + oSlug + "']")
                    .prop('selected', true);
                break;

            default:
                break;
        }

        parent.$('.NavBookmark').hide();
        parent.$('.NavSpage').toggle(true);
        parent.$('#menu_typeUrl').toggle(false);
    };

    $.fn.RVwysPageOption = function (pageData) {
        var othis = this;

        $.each(pageData, function (optkey, optval) {
            var optBlog = optval.opt_blog_group || optval.optgroup;
            var slugid = optval.opt_blog_slug_id || optval.opt_slugid;
            var slug = optval.opt_blog_slug || optval.optslug;
            var space = !optval.opt_blog_group
                ? '&nbsp;&nbsp;&nbsp;&nbsp;'
                : '';
            if (optBlog) {
                var opt = $(
                    `<option class="option-category" style="font-weight: bold;" id="${slugid}" value="${slug}">${space}${optBlog} </option>`
                );
                othis.append(opt);
                // othis.find("#" + optval.optid).RVwysPageOption(optval.data);
                othis.RVwysPageOption(optval.data);
            } else {
                var optval = optval.id ? optval : optval.data;
                var opt = $(
                    `<option id="${optval.id}"  value="${optval.slug_name}"> ${space}&nbsp;&nbsp;&nbsp;&nbsp;${optval.page_name} </option>`
                );
                othis.append(opt);
            }
        });
        return $(this);
    };

    RVwys.SetdataSystempage = function (DataConcat) {
        var optgroup = [];
        $.each(
            parent.wex.systempage.nonedit_module_lists,
            function (key, data) {
                var inOptgroup = {
                    optgroup: data.text,
                    optid: data.id,
                    data: '',
                };

                var oData = [];
                $.each(DataConcat, function (isKey, isData) {
                    if (data.id == isData.parent) {
                        var inData = {
                            id: isData.id,
                            page_name: isData.text,
                            slug_name: isData.slug_name,
                        };

                        oData.push(inData);
                    }
                    inOptgroup['data'] = oData;
                });

                if (inOptgroup['data'] != '') {
                    optgroup.push(inOptgroup);
                }
            }
        );

        return optgroup;
    };

    RVwys.setDataToSelectionBlog = function (...dataWex) {
        var htmlOption = $('<div/>');
        $.each(dataWex[0], function (isKey, isMain) {
            var space = isMain.parent == '#' ? '' : '&nbsp;&nbsp;&nbsp;&nbsp;';
            var opt = $(
                `<option class="option-category" style="font-weight: bold;" id="${isMain.slug_id}" value="${isMain.url}">${space}${isMain.text} </option>`
            );
            if (isMain.parent == '#') {
                var mainOpt = $(
                    `<option class="option-category" style="font-weight: bold;" id="${isMain.slug_id}" value="${isMain.url}">${isMain.text} </option>`
                );
                $(htmlOption, 'option').prepend(mainOpt);
            } else {
                htmlOption.append(opt);
            }

            $.each(dataWex[1], function (isKeyPost, objChild) {
                var optionLevel2 = `<option id="${objChild.slug_id}"  value="${objChild.url}"> ${space}${space}${objChild.text} </option>`;

                if (isMain.id == objChild.parent) {
                    // htmlOption += optionLevel2;
                    htmlOption
                        .find(`[id="${isMain.slug_id}"]`)
                        .after(optionLevel2);
                }
            });
        });
        htmlOption = htmlOption.prepend(`<option>Select blog</option>`);
        parent.$('#Navpage').html(htmlOption.html());
    };

    RVwys.setDataToSelectionPage = function (dataPage) {
        var htmlOption = '<option>Select page</option>';
        $.each(dataPage, function (isKey, isData) {
            var space = '&nbsp;&nbsp;&nbsp;&nbsp;';
            var optionLevel = `<option id="${isData.slug_id}"  value="${isData.slug_name}"> ${space}${isData.text} </option>`;
            htmlOption += optionLevel;
        });

        parent.$('#Navpage').html(htmlOption);
    };

    RVwys.uikit.showPanelNavgation = function (oThis) {
        console.log('RVwys.uikit.showPanelNavgation');
        RVwys.uikit.blockprop.NavSettingShow();
        menuNavID = oThis.attr('menu-id');
        menuSlug = oThis.attr('slug-id');
        var page_name = oThis.attr('menu-title');
        var menu_icon = oThis.attr('menu-icon');
        var badge_title = oThis.attr('menu-badge-title');
        var badge_style = oThis.attr('menu-badge-style');
        var link_open = oThis.attr('menu-target');
        var link_to = oThis.attr('menu-type');
        var menu_url = oThis.attr('menu-url');
        var slug_id = oThis.attr('slug-id');

        parent.$('.wys-navPropertie').attr('id', menuNavID);
        parent.$('#MenuNavID').val(menuNavID);
        parent.$('.delete_menu').attr('id', menuNavID);
        parent.$('#page_name').val(page_name);
        parent.$('#badge_title').val(badge_title);
        parent
            .$('#ViewIconMenu')
            .removeClass()
            .addClass(menu_icon)
            .addClass('uk-icon-medium');

        parent
            .$('#menu-target .menu-target')
            .filter("[value='" + link_open + "']")
            .prop('selected', true);
        parent
            .$('.menu_type')
            .filter("[value='" + link_to + "']")
            .prop('checked', true);

        parent.$('.ui-badge-padd').removeClass('uk-badge-active');

        if (badge_style != '') {
            parent
                .$('.colorgroupmenu')
                .find('.' + badge_style)
                .addClass('uk-badge-active');
        }

        parent.$('#badge_title').val() == ''
            ? parent.$('.NavBadgeStyle').hide()
            : parent.$('.NavBadgeStyle').show();

        var linkUrl = link_to == '4' ? true : false;
        console.log('linkUrl: ', linkUrl);
        if (linkUrl) {
            parent.$('#menu_typeUrl').val(menu_url);

            parent.$('#menu_typeUrl').toggle(linkUrl);
            parent.$('.NavSpage').toggle(!linkUrl);
            parent.$('.NavBookmark').toggle(!linkUrl);
        } else {
            link_to = link_to ? link_to : '1';

            RVwys.uikit.SelectPageNavigation(link_to, slug_id);
        }

        $('li[menu-id="' + menuNavID + '"]').find('li').length > 0
            ? parent.$('.delete_menu').hide()
            : parent.$('.delete_menu').show();
    };

    RVwys.Nav.Setting = function () {
        $('.bodyTemplate')
            .unbind('click')
            .click(function (e) {
                var $clicked = parent.$(e.target);

                if (!parent.clickFromEdit) {
                    if (!$clicked.parents().is('.rv_logo,.topmenu-minwidth')) {
                        parent.$('.wys-navPropertie ').hide(function () {});
                        $('.bodyTemplate').unbind('click');
                    }
                }
            });
    };
    // End Navigation Properties

    //		Sidebar
    RVwys.Sidebar.eventSidebar = function () {
        parent
            .$('[use_sidebar="' + parent.user_sidebar + '"]')
            .addClass('uk-active');
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-sidebarDesign').show();

        parent.$('.sidebar_full').click(function () {
            $('.sidebar-left').hide();
            $('.sidebar-right').hide();

            $('.container > .uk-container').addClass('rv-block-full');
            $('.sidebar-center')
                .removeClass(function (index, className) {
                    return (
                        className.match(/(^|\s)uk-width-large-\S+/g) || []
                    ).join(' ');
                })
                .addClass('uk-width-large-1-1');

            parent.user_sidebar = $(this).attr('use_sidebar');

            RVwys.setScollPostionFormDesign('setSidebar');
        });

        parent.$('.sidebar_left').click(function () {
            $('.sidebar-left').show();
            $('.sidebar-right').hide();

            $('.container > .uk-container').removeClass('rv-block-full');
            $('.sidebar-center')
                .removeClass(function (index, className) {
                    return (
                        className.match(/(^|\s)uk-width-large-\S+/g) || []
                    ).join(' ');
                })
                .addClass('uk-width-large-3-4');

            parent.user_sidebar = $(this).attr('use_sidebar');

            RVwys.setScollPostionFormDesign('setSidebar');
        });

        parent.$('.sidebar_right').click(function () {
            $('.sidebar-left').hide();
            $('.sidebar-right').show();

            $('.container > .uk-container').removeClass('rv-block-full');
            $('.sidebar-center')
                .removeClass(function (index, className) {
                    return (
                        className.match(/(^|\s)uk-width-large-\S+/g) || []
                    ).join(' ');
                })
                .addClass('uk-width-large-3-4');
            parent.user_sidebar = $(this).attr('use_sidebar');

            RVwys.setScollPostionFormDesign('setSidebar');
        });

        parent.$('.sidebar_both').click(function () {
            $('.sidebar-left').show();
            $('.sidebar-right').show();

            $('.container > .uk-container').removeClass('rv-block-full');
            $('.sidebar-center')
                .removeClass(function (index, className) {
                    return (
                        className.match(/(^|\s)uk-width-large-\S+/g) || []
                    ).join(' ');
                })
                .addClass('uk-width-large-2-4');

            parent.user_sidebar = $(this).attr('use_sidebar');

            RVwys.setScollPostionFormDesign('setSidebar');
        });
        // reset sidebar to default
        parent.$('#reset-sidebar').click(function () {
            var UI = parent.UIkit;

            var oncancel = function () {
                modal.hide();
            };

            var onInsert = function () {
                var typePost =
                    parent.$('#isType').val() == 'Post' ? true : false;
                var slug_id =
                    $('#slug_id').length == 1
                        ? $('#slug_id').val()
                        : parent.$('#slug_id').val();

                axiosResetSidebar({ slug_id: slug_id }).then(result => {
                    var user_sidebar = result.data.use_sidebar;
                    if (!typePost) {
                        parent
                            .$(`[use_sidebar="${user_sidebar}"]`)
                            .trigger('click');
                        parent.$('.wys-sidebarDesign').hide();

                        $('#editable_area_content1')
                            .empty()
                            .append(result.data.left_content_edit);
                        $('#editable_area_content2')
                            .empty()
                            .append(result.data.right_content_edit);

                        RVwys.setScollPostionFormDesign('setSidebar');
                        RVwys.EditorByClass('.RVWYSIWYGAREA');
                        RVwys.Sidebar.CustomSidebar();
                    } else {
                        console.log('result: ', result);
                        var sidebarLeft = $('<div/>').html(
                            result.data.left_content_edit
                        );

                        var sidebarRight = $('<div/>').html(
                            result.data.right_content_edit
                        );
                        var userSidebar = $('<div/>')
                            .html(result.data.left_content_edit)
                            .find('#use_reset')
                            .attr('use_reset');
                        console.log('userSidebar: ', userSidebar);
                        parent
                            .$(`[use_sidebar="${userSidebar}"]`)
                            .trigger('click');

                        sidebarLeft.find('#use_reset').remove();

                        parent.$('.wys-sidebarDesign').hide();

                        // left_content_edit
                        $('#editable_area_content1')
                            .empty()
                            .append(sidebarLeft.html());

                        // right_content_edit
                        $('#editable_area_content2')
                            .empty()
                            .append(sidebarRight.html());

                        RVwys.EditorByClass('.RVWYSIWYGAREA');
                        RVwys.Sidebar.CustomSidebar();
                    }

                    parent.isCustom_sidebar = '0';
                    isSidebar = '0';
                });

                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Reset Sidebar') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        rvLang('Reset Sidebar to default?') +
                        '</span></div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Yes') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('No') +
                        '</button></div>',
                    '</div>',
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        });
    };

    RVwys.Sidebar.CustomSidebarDesign = function () {
        var fb = $('#frameBody').get(0).contentWindow;

        if (parent.isCustom_sidebar == '0') {
            var overlayside_left = $(
                '<div class="overlayCustomside_left"></div>'
            ).css({
                'background-color': 'rgba(0, 0, 0, 0.6)',
                position: 'absolute',
                left: '0px',
                top: '0px',
                zIndex: '5',
                display: 'none',
                width: $('.sidebar-left #editable_area_content1').width(),
                height: $('.sidebar-left #editable_area_content1').height(),
            });

            var overlayside_right = $(
                '<div class="overlayCustomside_right"></div>'
            ).css({
                'background-color': 'rgba(0, 0, 0, 0.6)',
                position: 'absolute',
                left: '0px',
                top: '0px',
                zIndex: '5',
                display: 'none',
                width: fb.$('.sidebar-right #editable_area_content2').width(),
                height: fb.$('.sidebar-right #editable_area_content2').height(),
            });
        }
    };

    RVwys.Sidebar.EventClickDesign = function () {
        if (
            parent.$('#isHomepage').val() == '0' &&
            isSidebar == '0' &&
            parent.isCustom_sidebar == '0'
        ) {
            var UI = parent.UIkit;
            oncancel = function () {
                modal.hide();
            };

            var onInsert = function (e) {
                isSidebar = 1;
                parent.isCustom_sidebar = 1;
                $('.figsidebar').parent().removeClass();
                $('.figsidebar').remove();
                RVwys.Sidebar.eventSidebar();
                modal.hide();
            };

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>Custom Sidebar</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content">' +
                        rvLang(
                            'Sidebar in this page is Inherited from parent page.'
                        ) +
                        '</div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Custom this Sidebar?') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">Cancel</button>',
                    '</div>',
                    '</div>',
                ].join('')
            );
            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            modal.show();
        } else {
            RVwys.Sidebar.eventSidebar();
        }
    };

    RVwys.Sidebar.CustomSidebar = function () {
        if (
            parent.$('#isHomepage').val() == '0' &&
            parent.isCustom_sidebar == '0'
        ) {
            var sidebar = {
                1: 'sidebarleft',
                2: 'sidebarright',
            };

            $.each(sidebar, function (k, v) {
                $('#editable_area_content' + k)
                    .parent()
                    .addClass('rv-overlay uk-overlay ' + v);

                $(
                    '<figcaption class="uk-overlay-panel uk-overlay-background figsidebar panel' +
                        v +
                        '"  style="display:none;">' +
                        ' <div class="custom-title">' +
                        '<i class="uk-icon uk-icon-wrench"></i> Custom Sidebar' +
                        '  </div> ' +
                        ' </figcaption>'
                ).prependTo('.' + v);

                $('.' + v).hover(function () {
                    $('.panel' + v).toggle();
                });
            });

            $('.figsidebar').click(function () {
                isSidebar = 1;
                parent.isCustom_sidebar = 1;
                $('.figsidebar').parent().removeClass();
                $('.figsidebar').remove();
            });
        }
    };

    //		End Sidebar

    /***********************  Event Show Panel Design   ********************/

    RVwys.uikit.blockprop.Header = function () {
        parent.$('.wys-dynamic,.wys-rowTwo').hide();
        parent.$('.rv-head-hero,.wys-rowHeader, .panelHeader').show();
    };

    RVwys.uikit.blockprop.HeaderBanner = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-rowHeaderBanner, .panelHeader').show();
        RVwys.uikit.loadHeaderbannerDesign();
    };

    RVwys.uikit.blockprop.Nav = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-menuDesign, .panelMenu').show();
    };

    RVwys.uikit.blockprop.Banner = function () {
        parent.$('.wys-bannerDesign, .panelbanner').show();
    };

    RVwys.uikit.blockprop.BannerEffect = function () {
        RVwys.BannerDesign.EventSlide();
        parent.$('.wys-bannerEffects').show();
    };

    RVwys.uikit.blockprop.Topmenu = function () {
        parent.$('.wys-dynamic,.wys-panel,.wys-rowTwo').hide();
        parent.$('.wys-topmenuDesign, .panelTopmenu').show();
    };

    RVwys.uikit.blockprop.NavSettingShow = function () {
        parent.$('.wys-navPropertie, .panelMenuSet').show();
    };

    RVwys.uikit.blockprop.NavSettingHide = function () {
        parent.$('.wys-navPropertie').hide();
    };

    RVwys.uikit.blockprop.Brand = function () {
        parent.RVwys.hidePanelAll();
        parent.$('.wys-rowBrand ').show(RVwys.Brand.Setting());
    };
    /***********************  End Event Show Panel Design   ********************/

    /*********************** Load Design   ********************/
    RVwys.uikit.loadHeaderDesign = function (isEditPage) {
        var layout = $('.design-block').attr('rv-layout');
        if (layout == 'undefined' || layout == undefined) {
            setTimeout(function () {
                RVwys.uikit.loadHeaderDesign();
            }, 500);
        }

        if (parent.$('#headerAlbumUikit icon').length == '0') {
            parent
                .$('#headerAlbumUikit')
                .html('<div class="txtSidebar">Loading...</div>');
            var urlCDN = parent.wex.cdn.cdnHeaderDesign;
            var request = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            request.done(function (data) {
                //	        		alert(data);
                parent.$('#headerAlbumUikit').html('');
                var oRolsHeader = $('<div/>').html(data);
                oRolsHeader.find('icon').each(function () {
                    var headerID = oRolsHeader.find('icon').attr('header');
                    var IconHeader = $(this);
                    parent.$('#headerAlbumUikit').append($(this));
                    var urlCDNbyiTem =
                        parent.wex.cdn.cdnURL +
                        '/service/getdesign.php?name=headerdesign&item=' +
                        headerID;
                    var requestbyiTem = $.ajax({
                        method: 'POST',
                        url: urlCDNbyiTem,
                        dataType: 'html',
                    });

                    requestbyiTem.done(function (data) {
                        var oRolsHeaderHtml = $('<div/>').html(data);
                        var GroupSection = $('<div/>').html(
                            oRolsHeaderHtml.find('.selected_overlap')
                        );
                        IconHeader.find('.hvr-glow').attr(
                            'data',
                            GroupSection.html()
                        );
                    });
                });

                RVwys.HeaderDesign.HeaderPreview();
            });
        }

        request.fail(function (jqXHR, textStatus) {
            RVwys.uikit.loadHeaderDesign();
        });
    };

    RVwys.fatchiconHeaderbanner = function (oIcon, content, i, max) {
        var iconBan = oIcon.eq(i);
        var id = iconBan.attr('banner');
        var isType = iconBan.find('.banner-category').hasClass('rv-banner-hero')
            ? 'hero'
            : 'slide';

        if (isType == 'hero') {
            var conHTML = $('<div/>').html(
                content.find('[data-banner=' + id + ']')
            );
            var eleUL = $('<ul class="uk-slideshow-hero"/>').html(
                conHTML.html()
            );
            conHTML = $('<div/>').html(eleUL);
        } else {
            var conHTML = $('<div/>').html(
                content.find('[data-banner=' + id + ']').parent()
            );
        }

        var iconContent = iconBan.find('.hvr-glow').attr({
            banner: isType,
            data: conHTML.html(),
        });

        iconContent.click(function (e) {
            var isCkBanner = $(this).attr('banner') == 'hero' ? true : false;
            var oRodata = $('<div>').html($(this).attr('data'));
            useBanner = $('#selected_headerbanner .editable_area').is(
                '#editable_area_content-h'
            )
                ? true
                : false;

            var UI = parent.UIkit;

            var oncancel = function () {
                firstBanner = true;
                modal.hide();
            };

            var onInsert = function () {
                firstBanner = true;

                if (isCkBanner) {
                    RVwys.BannerDesign.EventSwitchHero(oRodata, e);
                } else {
                    RVwys.BannerDesign.EventSwitchSlide(oRodata, e);
                }

                modal.hide();
            };

            var langModal = isCkBanner
                ? rvLang(
                      'Switching from Slide to Hero will remove all existing slides.'
                  )
                : rvLang(
                      'Switching from Hero to Slide will remove all existing Hero.'
                  );

            var modal = UI.modal.dialog(
                [
                    '<div class="wys-rvdesign">',
                    '<div class="uk-margin uk-modal-header"><h2>' +
                        rvLang('Switch Banner') +
                        '</h2><span class="uk-modal-close uk-icon-close"></span></div>',
                    '<div class="uk-margin uk-modal-content"><span>' +
                        langModal +
                        '</span></div>',
                    '<div class="uk-modal-footer uk-text-left clear"><button class="uk-button uk-button-success  js-modal-confirm">' +
                        rvLang('Yes') +
                        '</button>',
                    '<button class="uk-button js-modal-confirm-cancel">' +
                        rvLang('No') +
                        '</button></div>',
                    '</div>',
                ].join('')
            );

            modal.element
                .find('.js-modal-confirm-cancel')
                .on('click', function () {
                    oncancel();
                })
                .end()
                .find('.uk-button-success')
                .on('click', function () {
                    onInsert();
                });

            if (isCkBanner) {
                if (!useBanner && firstBanner) {
                    modal.show();
                } else {
                    RVwys.BannerDesign.EventSwitchHero(oRodata, e);
                }
            } else {
                if (useBanner && firstBanner) {
                    modal.show();
                } else {
                    RVwys.BannerDesign.EventSwitchSlide(oRodata, e);
                }
                /*
						if(isCkBanner){
						}else{

						}
					 */
            }
        });

        parent.$('.wys-rowHeaderBanner #bannerAlbumUikit').append(iconContent);

        i++;

        if (i < max) {
            setTimeout(function () {
                RVwys.fatchiconHeaderbanner(oIcon, content, i, max);
            }, 50);
        } else {
            parent.$('.loadingBanner').hide();
            parent.$('.wys-rowHeaderBanner #bannerAlbumUikit').show();
            RVwys.HeaderDesign.HeaderBannerPreview();
        }
    };

    RVwys.uikit.loadHeaderbannerDesign = function () {
        var reqHeaderBanner = {};
        var oIcon;
        var loadingBanner = $(
            '<img class="loading" src="' +
                parent.wex.url.WYS_IMG_URL +
                'images/loading08.gif" width="32" height="32" border="0" align="absmiddle" /></div>'
        ).css({
            marginTop: '125px',
        });

        if (
            parent.$('.wys-rowHeaderBanner #bannerAlbumUikit .hvr-glow')
                .length == '0'
        ) {
            parent.$('.loadingBanner').append(loadingBanner);

            var urlCDN = parent.wex.cdn.cdnBannerDesign;
            var urlCDNbyiTem =
                parent.wex.cdn.cdnURL + '/service/getdesign.php?name=banner';

            reqHeaderBanner.icon = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            reqHeaderBanner.icon.done(function (data) {
                oIcon = data;
            });

            reqHeaderBanner.content = $.ajax({
                method: 'POST',
                url: urlCDNbyiTem,
                dataType: 'html',
            });

            reqHeaderBanner.content.done(function (data) {
                var content = $('<div/>').html(data);
                oIcon = $('<div/>').html(oIcon).find('icon').closest('icon');

                //	           		Load banner-hero only
                //	           		 oIcon = $('<div/>').html(oIcon).find('icon .rv-banner-hero').closest('icon');

                var oIconleng = oIcon.length;
                RVwys.fatchiconHeaderbanner(oIcon, content, 0, oIconleng);
            });
        }
    };

    RVwys.fatchiconbanner = function (oIcon, content, i, max) {
        var iconBan = oIcon.eq(i);
        var id = iconBan.attr('banner');
        var conHTML = $('<div/>').html(
            content.find('[data-banner=' + id + ']')
        );
        var iconContent = iconBan
            .find('.hvr-glow')
            .attr('data', conHTML.html());
        iconContent.click(function (e) {
            var addSlide = $('<div>').html($(this).attr('data'));

            var dataNum = $('[data-slideshow-slide]').length;
            //				var dotNum = $('[data-uk-slideshow-item]').length;
            var newCslide = dataNum + 1;
            var dotNav = $('<div>').html(
                '<li data-uk-slideshow-item="' +
                    dataNum +
                    '" class=""><a href=""></a></li>'
            );

            var buttonSlide =
                $(`<div class="uk-button btnSlide" data-slideshow-item="${dataNum}">
            <span>slide ${newCslide}</span>
            <a herf="" class="uk-icon-close delete-slide" style="display:none;" title="Delete"></a>
            <a href="javascript:void(0);" class="uk-icon uk-icon-photo bgSlide " id="BG_Slide" onclick="RVwys.uikit.blockprop.rowParallaxSlide('${dataNum}')" title="Change Image" style="display:none;"></a>
            <a style="display:none;" class="uk-icon-clone clone-slide" title="Duplicate"></a>
            </div>`);

            addSlide.find('li').attr('data-banner', dataNum);

            $('.delete-slide').show();
            $('.uk-slideshow').append(addSlide.html());
            $('.uk-dotnav').append(dotNav.html());
            $('.rv-Switchbanner').hide();
            RVwys.BannerDesign.eButtonSlide(buttonSlide);

            $('[data-slideshow-item]').removeClass('uk-active');
            $('[data-slideshow-item]').last().addClass('uk-active');
            $('[data-slideshow-item] #BG_Slide').hide();
            $('[data-slideshow-item]').last().find('#BG_Slide').show();

            RVwys.HeaderDesign.RegisHeader(e);
            RVwys.BannerDesign.RegisRVSlide(dataNum);
        });

        parent.$('.wys-bannerDesign #bannerAlbumUikit').append(iconContent);

        i++;

        if (i < max) {
            setTimeout(function () {
                RVwys.fatchiconbanner(oIcon, content, i, max);
            }, 50);
        }

        parent.$('.banner-category:not(.rv-banner-slide)').hide();
    };

    RVwys.uikit.loadBannerDesign = function (isEditPage) {
        var reqHeaderBanner = {};
        var oIcon;

        if (
            parent.$('.wys-bannerDesign #bannerAlbumUikit .hvr-glow').length ==
            '0'
        ) {
            var urlCDN = parent.wex.cdn.cdnBannerDesign;
            var urlCDNbyiTem =
                parent.wex.cdn.cdnURL + '/service/getdesign.php?name=banner';

            reqHeaderBanner.icon = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            reqHeaderBanner.icon.done(function (data) {
                oIcon = data;
            });

            reqHeaderBanner.content = $.ajax({
                method: 'POST',
                url: urlCDNbyiTem,
                dataType: 'html',
            });

            reqHeaderBanner.content.done(function (data) {
                var content = $('<div/>').html(data);
                oIcon = $('<div/>')
                    .html(oIcon)
                    .find('icon .rv-banner-slide')
                    .closest('icon');
                var oIconleng = oIcon.length;

                RVwys.fatchiconbanner(oIcon, content, 0, oIconleng);
            });
        }
    };

    RVwys.uikit.loadMenuDesign = function (isEditPage) {
        if (parent.$('#navAlbumUikit icon').length == '0') {
            parent
                .$('#navAlbumUikit')
                .html(
                    '<div class="txtSidebar uk-text-center" style="margin-top: 150px;">Loading...</div>'
                );
            var layout = $('.design-block').attr('rv-layout');
            if (layout == 'undefined' || layout == undefined) {
                setTimeout(function () {
                    RVwys.uikit.loadMenuDesign();
                }, 500);
            }
            var urlCDN = parent.wex.cdn.cdnMenuDesign;
            var request = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            request.done(function (data) {
                parent.$('#navAlbumUikit').html('');
                var oRolsMenu = $('<div/>').html(data);
                oRolsMenu.find('icon').each(function () {
                    var MenuID = oRolsMenu.find('icon').attr('menu');
                    var IconMenu = $(this);
                    parent.$('#navAlbumUikit').append($(this));
                });
                RVwys.MenuPreview();
            });

            request.fail(function (jqXHR, textStatus) {
                RVwys.uikit.loadMenuDesign();
            });
        }
    };

    RVwys.uikit.loadTopMenuDesign = function (isEditPage) {
        if (parent.$('#TopmenuAlbumUikit icon').length == '0') {
            parent
                .$('#TopmenuAlbumUikit')
                .html(
                    '<div class="txtSidebar uk-text-center" style="margin-top: 150px;">Loading...</div>'
                );
            var layout = $('.design-block').attr('rv-layout');
            if (layout == 'undefined' || layout == undefined) {
                setTimeout(function () {
                    RVwys.uikit.loadTopMenuDesign();
                }, 500);
            }

            var urlCDN = parent.wex.cdn.cdnTopmenuDesign;
            var request = $.ajax({
                method: 'POST',
                url: urlCDN,
                dataType: 'html',
            });

            request.done(function (data) {
                parent.$('#TopmenuAlbumUikit').html('');
                var oRolsTopmenu = $('<div/>').html(data);
                oRolsTopmenu.find('icon').each(function () {
                    var TopmenuID = oRolsTopmenu.find('icon').attr('topmenu');
                    var IconTopmenu = $(this);
                    parent.$('#TopmenuAlbumUikit').append($(this));
                    var urlCDNbyiTem =
                        parent.wex.cdn.cdnURL +
                        '/service/getdesign.php?name=topmenudesign&item=' +
                        TopmenuID;
                    var requestbyiTem = $.ajax({
                        method: 'POST',
                        url: urlCDNbyiTem,
                        dataType: 'html',
                    });
                    requestbyiTem.done(function (data) {
                        var oRolsTopmenuHtml = $('<div/>').html(data);
                        var GroupSection = $('<div/>').html(
                            oRolsTopmenuHtml.find('section')
                        );
                        IconTopmenu.find('.hvr-glow').attr(
                            'data',
                            GroupSection.html()
                        );
                    });
                });
                RVwys.TopmenuPreview();
            });

            request.fail(function (jqXHR, textStatus) {
                RVwys.uikit.loadTopMenuDesign();
            });
        }
    };

    RVwys.regisSection = function (e, EleSection) {
        var bms = $('#blockMainSetting');
        var i = 0;
        var oMG = EleSection.find('.mg');

        if (EleSection.find("div[contenteditable='true']").get(0)) {
            EleSection.find("div[contenteditable='true']").each(function () {
                if (!$(this).hasClass('RVWYSIWYGAREA')) {
                    var rvsb_design_block = RVwys.getParentByClass(
                        $(this),
                        'rvsb_design_block'
                    );
                    if (
                        !rvsb_design_block
                            .find('.navMenu-blockMainSetting')
                            .get(0)
                    ) {
                        rvsb_design_block.prepend(bms.html());
                    }

                    var idpref = $.md5(String(e.timeStamp));
                    var id = 'editable_area_custom' + idpref + i;
                    i++;
                    $(this)
                        .attr({
                            id: id,
                            'data-ph':
                                'Editable Area. Backspace tab to remove this block.',
                        })
                        .addClass('RVWYSIWYGAREA editorCurrent areaCustom');

                    RVwys.EditorByClass('#' + id, true);
                    oMG = $('#' + id).closest('.mg');

                    RVwys.UIgridSortable(oMG);
                }
            });
        } else {
            var rvsb_design_block = EleSection.find('.rvsb_design_block');
            if (!rvsb_design_block.find('.navMenu-blockMainSetting').get(0)) {
                rvsb_design_block.prepend(bms.html());
            }
        }

        oMG.mousedown(function (e) {
            parent.RVwys.getrowProperties = RVwys.getParentByClass(
                $(e.target),
                'rvsb_design_block'
            );

            RVwys.setCurrentRowBG(e.target);
            RVwys.setCurrentBGIMAGE(e.target);
            RVwys.setCurrentParallaxCustomSection(e.target);

            RVwys.setCurrentShadowSection(parent.RVwys.getrowProperties);
            RVwys.setCurrentOverlapSection(parent.RVwys.getrowProperties);
            RVwys.setCurrentBoxSection(parent.RVwys.getrowProperties);

            RVwys.eventClickblock(oMG);
        });
    };

    /*********************** End Load Design   ********************/

    RVwys.designViewAddEvent('mousedown', function (e) {
        var eHead = $(e.target).closest('#selected_headerbanner');

        if (eHead.get(0) && parent.$('#isHomepage').val() == '1') {
            $('.handledrowResetbanner').css({
                display: 'none !important',
            });
        }

        if (eHead.get(0)) {
            if (eHead.find('#editable_area_content-s')) {
                RVwys.BannerDesign.EventEditSlide();
            }

            //				 parent.$('.wys-rowFour').hide();
        } else {
            $('#selected_headerbanner .SlideProperty').hide();
        }
    });
})(jQuery);
